import React from 'react'
import Swal from 'sweetalert2'
import Constant, { getCurrency } from '../../Constant.js'
import axios from 'axios'
import moment from 'moment'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '../ConciergeEvent/conciergeEvent.css'
import 'react-toggle/style.css'
import ChaletAddOns from './ChaletAddOns.js'

class ConciergeChaletAdd extends React.Component {
  BOOKING_TYPE = 'CHALET'
  INITIAL_LOADING_DELAY = 2000

  state = {
    category_id: '',
    chalet_id: '',
    global_package_id: '',
    from_date: '',
    to_date: '',
    categoryList: [],
    chaletList: [],
    globalPackageList: [],
    slots: [],
    calendarDateCellStatus: {},
    calendarDate: moment().startOf('month').format('YYYY-MM-DD'),
    guestCount: 1,
    maxGuests: 10,
    minGuests: 1,
    phone: '',
    email: '',
    country_code: '',
    coupon: '',
    coupon_id: '',
    isCouponApplied: false,
    isCustomerOptional: false,
    cost_of_service: 0,
    total_nights: 0,
    total_price: 0,
    bookingData: {},
    isData: false,
    isLoading: false,
    initialLoading: false,
    isLoadingCategories: false,
    isLoadingChalets: false,
    isLoadingCalendar: false,
    isLoadingChaletDetails: false,
    isBooking: false,
    chaletDetails: null,
    showDetailsModal: false,
    selectedImageIndex: 0,
    showAllFacilities: false,
    addOnPopUp: 0,
    appOnData: {},
    showPaymentModal: false,
    isCancellingBooking: false,
    emailError: '',
    // Package selection modal state
    showPackageModal: false,
    selectedPackage: null,
    packageAvailableDates: [],
    // Global package selection modal state
    showGlobalPackageModal: false,
    selectedGlobalPackage: null,
    globalPackageCalendarDate: moment().startOf('month').format('YYYY-MM-DD'),
    isCheckingAvailability: false,
    // New availability state
    availabilityData: null,
    packages: [],
    chaletSlots: [],
    isLoadingPrice: false,
    calculatedPrice: null,
    checkInTime: '',
    checkOutTime: '',
    // Filter state
    filterOpen: false,
    filterCount: 0,
    filterBedrooms: 0,
    filterBathrooms: 0,
    filterLounge: 0,
    filterGuests: 0,
    filterPrice: { min: 0, max: 0 },
    showFacilitiesDropdown: false,
    selectedFacilities: [],
    facilityList: [],
    chalet_search: '',
    // Dynamic filter ranges from API
    filterRanges: {
      guests: { min: 0, max: 15 },
      price: { min: 0, max: 100 },
      bedrooms: { min: 0, max: 10 },
      bathrooms: { min: 0, max: 10 },
      lounges: { min: 0, max: 10 },
    },
  }

  customStyle = {
    listBox: {
      padding: 10,
      borderRadius: 10,
      border: '1px solid #eee',
      backgroundColor: '#fefefe',
      textAlign: 'center',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    listBoxSelected: {
      border: '2px solid #00547e',
      backgroundColor: '#f0f8ff',
    },
    listBoxImage: {
      height: 80,
      width: 80,
      objectFit: 'cover',
      borderRadius: 8,
    },
    listBoxLabel: {
      color: '#00547e',
      fontWeight: '600',
      fontSize: '15px',
      padding: '5px 0',
      textTransform: 'uppercase',
      margin: 0,
    },
  }

  componentDidMount() {
    this.initializeComponent()
  }

  renderInlineLoader = (height = 100) => (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: height, width: '100%' }}>
      <div
        style={{
          width: 30,
          height: 30,
          border: '3px solid #f3f3f3',
          borderTop: '3px solid #00547e',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}
      />
      <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
    </div>
  )

  renderEmptyState = (iconType, title, subtitle = '') => {
    const icons = {
      category: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#6c757d"
          strokeWidth="1.5"
        >
          <path d="M3 21h18M9 8h1M9 12h1M9 16h1M14 8h1M14 12h1M14 16h1M5 21V5a2 2 0 012-2h10a2 2 0 012 2v16" />
        </svg>
      ),
      chalet: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#6c757d"
          strokeWidth="1.5"
        >
          <path d="M3 21h18M4 21V10l8-6 8 6v11M9 21v-6h6v6" />
        </svg>
      ),
      guest: (
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#6c757d"
          strokeWidth="1.5"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle
            cx="9"
            cy="7"
            r="4"
          />
        </svg>
      ),
    }
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 20px',
          backgroundColor: '#f8f9fa',
          borderRadius: '12px',
          border: '1px dashed #dee2e6',
          marginTop: '15px',
        }}
      >
        <div
          style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            backgroundColor: '#e9ecef',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '15px',
          }}
        >
          {icons[iconType] || icons.category}
        </div>
        <h5 style={{ margin: '0 0 5px 0', fontSize: '16px', fontWeight: '600', color: '#495057' }}>{title}</h5>
        {subtitle && <p style={{ margin: 0, fontSize: '13px', color: '#6c757d', textAlign: 'center' }}>{subtitle}</p>}
      </div>
    )
  }

  initializeComponent = () => {
    this.loadCategories()
    this.loadGlobalPackages()
    this.setState({ initialLoading: true })
    setTimeout(() => this.setState({ initialLoading: false }), this.INITIAL_LOADING_DELAY)
  }

  getHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
    country_short_name: `${localStorage.getItem('countryShortName')}`,
  })

  handleApiError = (error) => {
    if (error?.response?.status === 401) {
      Constant.getAuthLogout()
    } else {
      const errorMessage =
        error?.response?.data?.data?.details?.[0]?.message ||
        error?.response?.data?.message ||
        'An error occurred. Please try again.'
      Swal.fire({ title: errorMessage, icon: 'error', confirmButtonColor: '#3085d6', confirmButtonText: 'Ok' })
    }
  }

  showInfoMessage = (message) => Swal.fire({ title: message, icon: 'info', confirmButtonText: 'Ok' })

  loadCategories = async () => {
    this.setState({ isLoadingCategories: true, categoryList: [], chaletList: [], category_id: '', chalet_id: '' })
    try {
      const response = await axios.get(`${Constant.getAPI()}/chalet/get-chalet-category-list`, {
        headers: this.getHeaders(),
      })
      if (response.data.success) {
        const categories = response.data.data || []
        this.setState({ categoryList: categories, category_id: categories[0]?.id || '' }, () => {
          if (categories.length > 0 && categories[0]?.id) {
            this.loadChalets(categories[0].id)
          } else {
            this.setState({ isLoadingCategories: false })
            if (categories.length === 0) this.showInfoMessage('No active Chalet categories available')
          }
        })
      }
    } catch (error) {
      this.handleApiError(error)
    } finally {
      this.setState({ isLoadingCategories: false })
    }
  }

  loadGlobalPackages = async () => {
    try {
      const response = await axios.get(`${Constant.getAPI()}/chalet/get-chalet-global-packages?is_concierge=1`, {
        headers: this.getHeaders(),
      })
      if (response.data.success) {
        const packages = response.data.data || []
        this.setState({ globalPackageList: packages, selectedGlobalPackage: packages[0] || null })
      }
    } catch (error) {
      console.error('Error loading global packages:', error)
    }
  }

  checkGlobalPackageAvailability = async (fromDate, toDate, packageId) => {
    this.setState({ isCheckingAvailability: true })
    try {
      const from = moment(fromDate, 'YYYY-MM-DD').format('MM/DD/YYYY')
      const to = moment(toDate, 'YYYY-MM-DD').format('MM/DD/YYYY')
      const response = await axios.get(
        `${Constant.getAPI()}/chalet/get-chalet-availability?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&package_id=${packageId}`,
        { headers: this.getHeaders() }
      )
      if (response.data.success) {
        return response.data.data
      }
      return null
    } catch (error) {
      console.error('Error checking availability:', error)
      return null
    } finally {
      this.setState({ isCheckingAvailability: false })
    }
  }

  openGlobalPackageModal = () => {
    const { globalPackageList } = this.state
    const firstPackage = globalPackageList[0] || null
    let calendarMonth = moment().startOf('month').format('YYYY-MM-DD')

    if (firstPackage?.slots?.length > 0) {
      calendarMonth = moment(firstPackage.slots[0].date, 'MM/DD/YYYY').startOf('month').format('YYYY-MM-DD')
    }

    this.setState({
      showGlobalPackageModal: true,
      selectedGlobalPackage: firstPackage,
      globalPackageCalendarDate: calendarMonth,
      from_date: '',
      to_date: '',
    })
  }

  closeGlobalPackageModal = () => {
    this.setState({ showGlobalPackageModal: false })
  }

  selectGlobalPackage = (pkg) => {
    let calendarMonth = this.state.globalPackageCalendarDate
    if (pkg?.slots?.length > 0) {
      calendarMonth = moment(pkg.slots[0].date, 'MM/DD/YYYY').startOf('month').format('YYYY-MM-DD')
    }
    this.setState({
      selectedGlobalPackage: pkg,
      globalPackageCalendarDate: calendarMonth,
      from_date: '',
      to_date: '',
    })
  }

  changeGlobalPackageCalendarMonth = (forward) => {
    const newDate = moment(this.state.globalPackageCalendarDate)
      .add(forward ? 1 : -1, 'month')
      .format('YYYY-MM-DD')
    this.setState({ globalPackageCalendarDate: newDate })
  }

  getGlobalPackageDateClass = (day) => {
    const { globalPackageCalendarDate, selectedGlobalPackage, from_date, to_date } = this.state
    const date = moment(globalPackageCalendarDate).date(day).format('YYYY-MM-DD')
    const dateFormatted = moment(date).format('MM/DD/YYYY')

    // Past dates
    if (moment(date).isBefore(moment(), 'day')) {
      return 'disabled'
    }

    // Selected range
    if (from_date && to_date) {
      if (moment(date).isSameOrAfter(from_date, 'day') && moment(date).isSameOrBefore(to_date, 'day')) {
        return 'selected'
      }
    } else if (from_date && moment(date).isSame(from_date, 'day')) {
      return 'selected'
    }

    // Check if date is in package slots
    if (selectedGlobalPackage?.slots) {
      const isInPackage = selectedGlobalPackage.slots.some(slot => slot.date === dateFormatted)
      if (isInPackage) {
        // Check if this can be a valid start date
        if (selectedGlobalPackage.no_of_days) {
          const canStart = this.canBeGlobalPackageStartDate(date, selectedGlobalPackage)
          return canStart ? 'available start-valid' : 'available'
        }
        return 'available start-valid'
      }
    }

    return 'unavailable'
  }

  canBeGlobalPackageStartDate = (date, pkg) => {
    if (!pkg?.slots || !pkg.no_of_days) return false
    const startDate = moment(date)
    const packageDates = pkg.slots.map(slot => slot.date)

    for (let i = 0; i < pkg.no_of_days; i++) {
      const checkDate = startDate.clone().add(i, 'days').format('MM/DD/YYYY')
      if (!packageDates.includes(checkDate)) {
        return false
      }
    }
    return true
  }

  selectGlobalPackageDate = async (day) => {
    const { globalPackageCalendarDate, selectedGlobalPackage } = this.state
    const date = moment(globalPackageCalendarDate).date(day).format('YYYY-MM-DD')
    const dateFormatted = moment(date).format('MM/DD/YYYY')

    // Check if date is in past
    if (moment(date).isBefore(moment(), 'day')) {
      return
    }

    // Check if date is in package
    if (!selectedGlobalPackage?.slots?.some(slot => slot.date === dateFormatted)) {
      return
    }

    // If package has fixed days, auto-calculate end date
    if (selectedGlobalPackage.no_of_days) {
      if (!this.canBeGlobalPackageStartDate(date, selectedGlobalPackage)) {
        return
      }
      const endDate = moment(date).add(selectedGlobalPackage.no_of_days - 1, 'days').format('YYYY-MM-DD')
      this.setState({ from_date: date, to_date: endDate })
    } else {
      // Manual selection for packages without fixed days
      const { from_date, to_date } = this.state
      if (!from_date || (from_date && to_date)) {
        this.setState({ from_date: date, to_date: '' })
      } else {
        if (moment(date).isBefore(moment(from_date))) {
          this.setState({ from_date: date, to_date: '' })
        } else {
          this.setState({ to_date: date })
        }
      }
    }
  }

  proceedWithGlobalPackage = async () => {
    const { from_date, to_date, selectedGlobalPackage, category_id } = this.state

    if (!from_date || !to_date) {
      Swal.fire('Please select check-in and check-out dates', '', 'warning')
      return
    }

    // Check availability
    const availability = await this.checkGlobalPackageAvailability(from_date, to_date, selectedGlobalPackage?.id)

    if (availability && !availability.available) {
      Swal.fire({
        title: 'Not Available',
        text: 'Chalets are not available for this date range. Please select another dates.',
        icon: 'warning',
        confirmButtonText: 'Ok'
      })
      return
    }

    // Close modal and set package_id, also sync main calendar to same month
    const calendarMonth = moment(from_date).startOf('month').format('YYYY-MM-DD')
    this.setState({
      showGlobalPackageModal: false,
      global_package_id: selectedGlobalPackage?.id || '',
      selectedPackage: selectedGlobalPackage,
      calendarDate: calendarMonth, // Sync main calendar to the same month
      packageAvailableDates: selectedGlobalPackage?.slots?.map(slot => slot.date) || [],
    }, () => {
      // Reload chalets with the selected package and dates
      if (category_id) {
        this.loadChalets(category_id)
      }
    })
  }

  clearDateSelection = () => {
    this.setState({
      from_date: '',
      to_date: '',
      global_package_id: '',
      selectedGlobalPackage: null,
      selectedPackage: null,
      total_nights: 0,
      calculatedPrice: null,
    }, () => {
      if (this.state.category_id) {
        this.loadChalets(this.state.category_id)
      }
    })
  }

  // Filter methods
  updateFilterCount = () => {
    let count = 0
    if (this.state.filterBedrooms > 0) count++
    if (this.state.filterBathrooms > 0) count++
    if (this.state.filterLounge > 0) count++
    if (this.state.filterGuests > 0) count++
    if (this.state.filterPrice.min > 0 || this.state.filterPrice.max > 0) count++
    if (this.state.selectedFacilities.length > 0) count++
    this.setState({ filterCount: count })
  }

  incrementFilter = (field) => {
    const fieldMap = {
      filterGuests: 'guests',
      filterBedrooms: 'bedrooms',
      filterBathrooms: 'bathrooms',
      filterLounge: 'lounges',
    }
    const rangeKey = fieldMap[field]
    const maxValue = rangeKey ? this.state.filterRanges[rangeKey]?.max : 999

    if (this.state[field] < maxValue) {
      this.setState({ [field]: this.state[field] + 1 }, () => this.updateFilterCount())
    }
  }

  decrementFilter = (field) => {
    if (this.state[field] > 0) {
      this.setState({ [field]: this.state[field] - 1 }, () => this.updateFilterCount())
    }
  }

  toggleFacility = (facilityId) => {
    const { selectedFacilities } = this.state
    if (selectedFacilities.includes(facilityId)) {
      this.setState({ selectedFacilities: selectedFacilities.filter(id => id !== facilityId) }, () => this.updateFilterCount())
    } else {
      this.setState({ selectedFacilities: [...selectedFacilities, facilityId] }, () => this.updateFilterCount())
    }
  }

  applyFilters = () => {
    this.setState({ filterOpen: false })
    if (this.state.category_id) {
      this.loadChalets(this.state.category_id)
    }
  }

  resetFilters = () => {
    this.setState({
      filterBedrooms: 0,
      filterBathrooms: 0,
      filterLounge: 0,
      filterGuests: 0,
      filterPrice: { min: 0, max: 0 },
      selectedFacilities: [],
      filterCount: 0,
      from_date: '',
      to_date: '',
      global_package_id: '',
      selectedGlobalPackage: null,
    }, () => {
      if (this.state.category_id) {
        this.loadChalets(this.state.category_id)
      }
    })
  }

  handleChaletSearch = (e) => {
    this.setState({ chalet_search: e.target.value }, () => {
      if (this.state.category_id) {
        this.loadChalets(this.state.category_id)
      }
    })
  }

  loadChalets = async (category_id) => {
    this.setState({ isLoadingChalets: true, chaletList: [], chalet_id: '', slots: [] })
    try {
      // Use selected dates or default to current month
      const fromDate = this.state.from_date || moment().format('YYYY-MM-DD')
      const toDate = this.state.to_date || moment().add(1, 'month').format('YYYY-MM-DD')

      const requestBody = {
        categoryId: category_id,
        from: moment(fromDate, 'YYYY-MM-DD').format('MM/DD/YYYY'),
        to: moment(toDate, 'YYYY-MM-DD').format('MM/DD/YYYY'),
        guests: this.state.guestCount,
        page: 1,
        limit: 100,
        include: ["filters"],
        package_id: "",
        number_of_guests: "",
        number_of_bedrooms: "",
        number_of_bathrooms: "",
        number_of_lounges: "",
        facilties: ""
      }
      if (this.state.global_package_id) requestBody.package_id = this.state.global_package_id
      // Add filter parameters (using API schema field names)
      if (this.state.filterBedrooms > 0) requestBody.number_of_bedrooms = this.state.filterBedrooms
      if (this.state.filterBathrooms > 0) requestBody.number_of_bathrooms = this.state.filterBathrooms
      if (this.state.filterLounge > 0) requestBody.number_of_lounges = this.state.filterLounge
      if (this.state.filterGuests > 0) requestBody.number_of_guests = this.state.filterGuests
      if (this.state.filterPrice.min > 0) requestBody.min_price = this.state.filterPrice.min
      if (this.state.filterPrice.max > 0) requestBody.max_price = this.state.filterPrice.max
      if (this.state.selectedFacilities.length > 0) requestBody.facilties = this.state.selectedFacilities
      if (this.state.chalet_search) requestBody.keyword = this.state.chalet_search

      const response = await axios.post(`${Constant.getAPI()}/chalet/get-chalet-list`, requestBody, {
        headers: this.getHeaders(),
      })
      if (response.data.success) {
        const chalets = response.data.data?.chalets || []
        const filters = response.data.data?.filters || []

        // Extract filter ranges from API response
        const filterRanges = { ...this.state.filterRanges }
        let facilityList = []

        filters.forEach(filter => {
          if (filter.filter_type === 'guests') {
            filterRanges.guests = filter.filter_values
          } else if (filter.filter_type === 'price') {
            filterRanges.price = filter.filter_values
          } else if (filter.filter_type === 'bedrooms') {
            filterRanges.bedrooms = filter.filter_values
          } else if (filter.filter_type === 'bathrooms') {
            filterRanges.bathrooms = filter.filter_values
          } else if (filter.filter_type === 'lounges') {
            filterRanges.lounges = filter.filter_values
          } else if (filter.filter_type === 'facilities') {
            facilityList = filter.filter_values || []
          }
        })

        this.setState({
          chaletList: chalets,
          chalet_id: chalets[0]?.id || '',
          isLoadingChalets: false,
          filterRanges: filterRanges,
          facilityList: facilityList,
        }, () => {
          if (chalets.length > 0 && chalets[0]?.id) {
            this.loadChaletAvailability(chalets[0].id)
          } else if (chalets.length === 0) {
            this.showInfoMessage('No chalets available for selected criteria')
          }
        })
      }
    } catch (error) {
      this.handleApiError(error)
    } finally {
      this.setState({ isLoadingChalets: false })
    }
  }

  loadChaletAvailability = async (chaletId) => {
    if (!chaletId) return
    // Preserve dates if global package is selected
    const preserveDates = !!this.state.global_package_id
    this.setState({
      isLoadingCalendar: true,
      slots: [],
      packages: [],
      chaletSlots: [],
      selectedPackage: preserveDates ? this.state.selectedPackage : null,
      from_date: preserveDates ? this.state.from_date : '',
      to_date: preserveDates ? this.state.to_date : '',
      calculatedPrice: null,
    })
    try {
      const payload = {
        chalet_id: chaletId,
        date: '',
        offer_id: '',
        from: '',
        to: '',
        global_package_id: '',
      }
      const response = await axios.post(`${Constant.getAPI()}/chalet/check-available-slots`, payload, {
        headers: this.getHeaders(),
      })
      if (response.data.success) {
        const data = response.data.data
        const packages = data.packages || []
        const chaletSlots = data.selectedChalet?.slots || []

        // Build slot availability map
        const dateSlotObj = {}
        chaletSlots.forEach((slot) => {
          const slotDate = moment(slot.date, 'YYYY-MM-DD')
          dateSlotObj[`date-${parseInt(slotDate.format('DD'))}`] = { enable: !slot.is_disabled, price: null }
        })

        // Auto-select package if global package is selected (match by ref_package_id)
        let autoSelectedPackage = null
        if (this.state.global_package_id && packages.length > 0) {
          autoSelectedPackage = packages.find(pkg => pkg.ref_package_id === this.state.global_package_id)
        }

        this.setState({
          availabilityData: data,
          packages: packages,
          chaletSlots: chaletSlots,
          slots: chaletSlots,
          calendarDateCellStatus: dateSlotObj,
          maxGuests: data.selectedChalet?.max_guests || 10,
          checkInTime: data.check_in_time || '',
          checkOutTime: data.check_out_time || '',
          selectedPackage: autoSelectedPackage || (preserveDates ? this.state.selectedPackage : null),
          packageAvailableDates: autoSelectedPackage?.slots?.map(slot => slot.date) || (preserveDates ? this.state.packageAvailableDates : []),
        }, () => {
          // Calculate price if package is auto-selected and dates are available
          if (autoSelectedPackage && this.state.from_date && this.state.to_date) {
            this.calculateChaletPrice()
          }
        })
      }
    } catch (error) {
      this.handleApiError(error)
    } finally {
      this.setState({ isLoadingCalendar: false })
    }
  }

  calculateChaletPrice = async () => {
    const { chalet_id, from_date, to_date, selectedPackage } = this.state
    if (!chalet_id || !from_date || !to_date) return

    this.setState({ isLoadingPrice: true })
    try {
      const payload = {
        chalet_id: chalet_id,
        start_date: moment(from_date).format('MM/DD/YYYY'),
        end_date: moment(to_date).format('MM/DD/YYYY'),
      }
      if (selectedPackage?.id) payload.package_id = selectedPackage.id

      const response = await axios.post(`${Constant.getAPI()}/chalet/calculate-chalet-price`, payload, {
        headers: this.getHeaders(),
      })
      if (response.data.success) {
        this.setState({ calculatedPrice: response.data.data, total_price: response.data.data.price || 0 })
      }
    } catch (error) {
      this.handleApiError(error)
    } finally {
      this.setState({ isLoadingPrice: false })
    }
  }

  handleChange = (event) => {
    const { name, value, checked, type } = event.target
    const newValue = type === 'checkbox' ? checked : value
    this.setState({ [name]: newValue }, () => {
      if (name === 'category_id') this.loadChalets(value)
      else if (name === 'global_package_id' && this.state.category_id) this.loadChalets(this.state.category_id)
      else if (name === 'cost_of_service' && parseFloat(value) < 0) this.setState({ cost_of_service: 0 })
      else if (name === 'email') {
        if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
          this.setState({ emailError: 'Please enter a valid email address' })
        else this.setState({ emailError: '' })
      }
    })
  }

  selectCalendarDate = (day, isEndDate = false) => {
    const date = moment(this.state.calendarDate).date(day).format('YYYY-MM-DD')
    if (!date || moment(date).isBefore(moment().subtract(1, 'day'))) return

    const normalizedDate = moment(date).format('MM/DD/YYYY')
    const slotData = this.state.slots.find((slot) => slot.date === normalizedDate)
    if (!slotData?.is_available) {
      Swal.fire('This date is not available', '', 'warning')
      return
    }

    if (isEndDate) {
      if (moment(date).isBefore(moment(this.state.from_date))) {
        Swal.fire('End date cannot be before start date', '', 'warning')
        return
      }
      this.setState(
        { to_date: date, total_nights: moment(date).diff(moment(this.state.from_date), 'days') },
        this.calculateTotalPrice
      )
    } else {
      let newToDate = this.state.to_date
      if (moment(this.state.to_date).isBefore(moment(date))) newToDate = moment(date).add(1, 'day').format('YYYY-MM-DD')
      this.setState(
        { from_date: date, to_date: newToDate, total_nights: moment(newToDate).diff(moment(date), 'days') },
        () => {
          this.calculateTotalPrice()
          this.loadChaletAvailability(this.state.chalet_id)
        }
      )
    }
  }

  calculateTotalPrice = () => {
    const { from_date, to_date, slots } = this.state
    let totalPrice = 0
    let currentDate = moment(from_date)
    const endDate = moment(to_date)
    while (currentDate.isBefore(endDate)) {
      const dateStr = currentDate.format('MM/DD/YYYY')
      const slot = slots.find((s) => s.date === dateStr)
      if (slot?.price) totalPrice += slot.price
      currentDate.add(1, 'day')
    }
    this.setState({ total_price: totalPrice })
  }

  changeCalendarMonth = (forward) => {
    const newDate = moment(this.state.calendarDate)
      .add(forward ? 1 : -1, 'month')
      .format('YYYY-MM-DD')
    this.setState({ calendarDate: newDate })
  }

  calendarDateColor = (day) => {
    const date = moment(this.state.calendarDate).date(day).format('YYYY-MM-DD')
    const { from_date, to_date, slots } = this.state

    // Past dates
    if (moment(date).isBefore(moment().subtract(1, 'day'))) return 'month-date disabled'

    // Selected range
    if (from_date && moment(date).isSame(from_date, 'day')) return 'select-blue start-date'
    if (to_date && moment(date).isSame(to_date, 'day')) return 'select-blue end-date'
    if (from_date && to_date && moment(date).isAfter(from_date) && moment(date).isBefore(to_date))
      return 'light-blue in-range'

    const normalizedDate = moment(date).format('MM/DD/YYYY')
    const slotData = slots.find((slot) => slot.date === normalizedDate)
    return slotData?.is_available ? 'light-blue' : 'month-date unavailable'
  }

  getDatePrice = (day) => {
    const date = moment(this.state.calendarDate).date(day).format('MM/DD/YYYY')
    const slot = this.state.slots.find((s) => s.date === date && s.is_available === true)
    return slot ? slot.price : null
  }

  incrementGuest = () => {
    if (this.state.guestCount >= this.state.maxGuests) {
      Swal.fire('Maximum guests reached!', '', 'error')
      return
    }
    this.setState(
      (prev) => ({ guestCount: prev.guestCount + 1 }),
      () => {
        if (this.state.chalet_id) this.loadChaletAvailability(this.state.chalet_id)
      }
    )
  }

  decrementGuest = () => {
    if (this.state.guestCount <= this.state.minGuests) {
      Swal.fire('Minimum 1 guest required!', '', 'error')
      return
    }
    this.setState(
      (prev) => ({ guestCount: prev.guestCount - 1 }),
      () => {
        if (this.state.chalet_id) this.loadChaletAvailability(this.state.chalet_id)
      }
    )
  }

  validateCoupon = async () => {
    if (!this.state.coupon.trim()) {
      Swal.fire('Coupon code required!', '', 'error')
      return
    }
    this.setState({ isLoading: true, isCustomerOptional: false, coupon_id: '' })
    try {
      const response = await axios.post(
        `${Constant.getAPI()}/booking/verify-coupon`,
        {
          cruise_id: this.state.chalet_id,
          booking_date: moment(this.state.from_date, 'YYYY-MM-DD').format('YYYY/MM/DD'),
          coupon: this.state.coupon,
        },
        { headers: this.getHeaders() }
      )
      if (response.data.success) {
        const couponData = response.data.data
        const isFullDiscount = couponData.amount_type === 'PERCENTAGE' && couponData.coupon_amount === 100
        this.setState({ isCouponApplied: true, coupon_id: couponData.id, isCustomerOptional: isFullDiscount })
        Swal.fire(response.data.message, '', 'success')
      }
    } catch (error) {
      this.handleApiError(error)
    } finally {
      this.setState({ isLoading: false })
    }
  }

  removeCoupon = () => this.setState({ coupon: '', isCouponApplied: false, isCustomerOptional: false, coupon_id: '' })

  validateBookingForm = () => {
    if (!this.state.chalet_id) {
      Swal.fire('Please select a Chalet!', '', 'error')
      return false
    }
    if (!this.state.from_date) {
      Swal.fire('Please select a check-in date!', '', 'error')
      return false
    }
    if (!this.state.to_date) {
      Swal.fire('Please select a check-out date!', '', 'error')
      return false
    }
    if (moment(this.state.to_date).isSameOrBefore(moment(this.state.from_date))) {
      Swal.fire('Check-out date must be after check-in date!', '', 'error')
      return false
    }
    const isCouponAppliedWithZeroAmount =
      this.state.isCouponApplied && this.state.bookingData?.total_booking_amount === 0
    if (!this.state.isCustomerOptional && !isCouponAppliedWithZeroAmount) {
      if (!this.state.country_code) {
        Swal.fire('Country code is required!', '', 'error')
        return false
      }
      if (!this.state.phone) {
        Swal.fire('Customer number is required!', '', 'error')
        return false
      }
    }
    if (this.state.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email)) {
      Swal.fire('Please enter a valid email address!', '', 'error')
      return false
    }
    return true
  }

  handleBooking = async () => {
    if (!this.validateBookingForm()) return

    // Use admin-chalet-book API as per admin-chalet-apis.md
    const bookingPayload = {
      chalet_id: this.state.chalet_id,
      start_date: moment(this.state.from_date, 'YYYY-MM-DD').format('MM/DD/YYYY'),
      end_date: moment(this.state.to_date, 'YYYY-MM-DD').format('MM/DD/YYYY'),
      isPackage: !!this.state.selectedPackage?.id,
      phone: this.state.phone || '',
      country_code: this.state.country_code || '',
      email: this.state.email || '',
      coupon: this.state.coupon || '',
      cost_of_service: this.state.cost_of_service || 0,
    }
    if (this.state.selectedPackage?.id) bookingPayload.package_id = this.state.selectedPackage.id

    this.setState({ isData: true, isBooking: true })
    try {
      const response = await axios.post(`${Constant.getAPI()}/chalet/admin-chalet-book`, bookingPayload, {
        headers: this.getHeaders(),
      })
      if (response.data.success) {
        const bookingData = response.data.data
        this.setState({ bookingData: bookingData }, () => {
          // Check storeTypes from the response
          if (bookingData.storeTypes?.length > 0) {
            const tabArray = bookingData.storeTypes.filter(
              (item) => item.isAvailable === 1 || item.isAvailable === true
            )
            if (tabArray.length > 0) {
              this.setState({
                appOnData: {
                  id: bookingData.id,
                  chalet_id: bookingData.chalet_id,
                  chalet_name: bookingData.chalet_name,
                  check_in_time: bookingData.check_in_time,
                  check_out_time: bookingData.check_out_time,
                  tab: tabArray,
                  bookingPayload: {
                    phone: this.state.phone,
                    email: this.state.email,
                    country_code: this.state.country_code,
                    guests: this.state.guestCount,
                    coupon_id: this.state.coupon_id || '',
                    cost_of_service: this.state.cost_of_service,
                    start_date: bookingData.start_date,
                    end_date: bookingData.end_date,
                    package_id: bookingData.package_id,
                  },
                },
                addOnPopUp: 1,
              })
            } else this.showPaymentConfirmation()
          } else this.showPaymentConfirmation()
        })
      } else
        Swal.fire({
          title: response.data.message || 'Booking failed. Please try again.',
          icon: 'error',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok',
        })
    } catch (error) {
      this.handleApiError(error)
    } finally {
      this.setState({ isData: false, isBooking: false })
    }
  }

  processPayment = async () => {
    this.setState({ isBooking: true })
    try {
      // Process payment without addons - just the chalet booking
      const response = await axios.post(
        `${Constant.getAPI()}/chalet/process-chalet-payment`,
        {
          booking_id: this.state.bookingData?.id,
          additional_items_list: [],
          diwaniya_items_list: [],
          DisplayCurrencyIso: this.state.bookingData?.currency,
        },
        { headers: this.getHeaders() }
      )
      if (response?.data?.success) {
        await Swal.fire({
          title: 'Payment Link Sent!',
          icon: 'success',
          text: 'Payment link has been sent to customer via WhatsApp and Email',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'View Booking Details',
        })
          .then(() => {
            window.location.href = `#/chalet-booking-details/${this.state.bookingData?.id}`
          })
          .finally(() => {
            this.resetForm()
          })
      }
    } catch (error) {
      this.handleApiError(error)
    } finally {
      this.setState({ isBooking: false })
    }
  }

  onCheckout = async (data) => {
    this.setState({ isData: true, isLoading: true })
    try {
      const res = await axios.post(Constant.getAPI() + '/chalet/admin-chalet-checkout', data, {
        headers: this.getHeaders(),
      })
      if (res.data.success) {
        this.setState({ bookingData: res.data.data })
        if (res.data.data.storeTypes?.length > 0) {
          const tabArray = res.data.data.storeTypes.filter((item) => item.isAvailable)
          if (tabArray.length > 0) {
            this.setState({
              appOnData: {
                id: res.data.data.id,
                chalet_id: res.data.data.chalet_id,
                chalet_data: res.data.data.chalet,
                tab: tabArray,
                bookingPayload: {
                  phone: this.state.phone,
                  email: this.state.email,
                  country_code: this.state.country_code,
                  guests: this.state.guestCount,
                  coupon_id: this.state.coupon_id || '',
                  cost_of_service: this.state.cost_of_service,
                },
              },
              addOnPopUp: 1,
            })
          } else this.showPaymentConfirmation()
        } else this.showPaymentConfirmation()
      }
    } catch (error) {
      this.handleApiError(error)
    } finally {
      this.setState({ isData: false, isLoading: false })
    }
  }

  handleDataFromChild = (data) => {
    this.setState({ addOnPopUp: 0 })
    this.onCheckout(data)
  }

  // Cancel chalet booking when addon modal is closed
  cancelChaletBooking = async () => {
    const bookingId = this.state.bookingData?.id
    if (!bookingId) {
      this.setState({ addOnPopUp: 0, appOnData: {}, isCancellingBooking: false })
      return
    }

    this.setState({ isCancellingBooking: true })
    try {
      await axios.post(
        `${Constant.getAPI()}/chalet/cancel-chalet-booking`,
        { booking_id: bookingId },
        { headers: this.getHeaders() }
      )
    } catch (error) {
      console.error('Error cancelling booking:', error)
    } finally {
      this.setState({
        addOnPopUp: 0,
        appOnData: {},
        bookingData: {},
        isCancellingBooking: false,
        isLoading: false,
        isLoadingCalendar: false,
        isLoadingPrice: false,
      })
    }
  }

  showPaymentConfirmation = () => this.setState({ showPaymentModal: true })
  closePaymentModal = async () => {
    this.setState({ showPaymentModal: false, isLoading: true })
    // Call cancel chalet API when closing the payment modal
    const bookingId = this.state.bookingData?.id
    if (bookingId) {
      try {
        await axios.post(
          `${Constant.getAPI()}/chalet/cancel-chalet-booking`,
          { booking_id: bookingId },
          { headers: this.getHeaders() }
        )
      } catch (error) {
        console.error('Error cancelling booking:', error)
      } finally {
        this.setState({ bookingData: {}, isLoading: false })
      }
    }
  }
  showChaletDetails = async (chaletId) => {
    this.setState({ isLoadingChaletDetails: true, showDetailsModal: true, chaletDetails: null })
    try {
      const response = await axios.get(`${Constant.getAPI()}/chalet/get-chalet-details/${chaletId}?is_concierge=1`, {
        headers: this.getHeaders(),
      })
      if (response.data.success) {
        this.setState({ chaletDetails: response.data.data, isLoadingChaletDetails: false })
      } else {
        this.setState({ isLoadingChaletDetails: false })
        Swal.fire('Failed to load chalet details', '', 'error')
      }
    } catch (error) {
      this.setState({ isLoadingChaletDetails: false })
      this.handleApiError(error)
    }
  }
  closeChaletDetails = () =>
    this.setState({ showDetailsModal: false, chaletDetails: null, selectedImageIndex: 0, showAllFacilities: false })

  resetForm = () =>
    this.setState({
      phone: '',
      email: '',
      coupon: '',
      country_code: '',
      cost_of_service: 0,
      isCustomerOptional: false,
      isCouponApplied: false,
      guestCount: 1,
      coupon_id: '',
      addOnPopUp: 0,
      appOnData: {},
      from_date: '',
      to_date: '',
      total_nights: 0,
      total_price: 0,
      selectedPackage: null,
      global_package_id: '',
      packageAvailableDates: [],
      calculatedPrice: null,
      packages: [],
      chaletSlots: [],
    })

  // Package Modal Methods
  openPackageModal = () => {
    this.setState({ showPackageModal: true })
  }

  closePackageModal = () => {
    this.setState({ showPackageModal: false })
  }

  selectPackage = (pkg) => {
    console.log(pkg)
    const availableDates = pkg?.slots?.map((slot) => slot.date) || []
    // Navigate calendar to the month of first available slot for this package
    let calendarMonth = this.state.calendarDate
    if (availableDates.length > 0) {
      calendarMonth = moment(availableDates[0], 'MM/DD/YYYY').startOf('month').format('YYYY-MM-DD')
    }
    this.setState({
      selectedPackage: pkg,
      global_package_id: pkg?.id || '',
      packageAvailableDates: availableDates,
      calendarDate: calendarMonth,
      from_date: '',
      to_date: '',
      total_nights: 0,
      calculatedPrice: null,
    })
  }

  togglePackage = (pkg) => {
    const { selectedPackage } = this.state
    // If same package is clicked, deselect it
    if (selectedPackage?.id === pkg.id) {
      this.clearPackageSelection()
    } else {
      this.selectPackage(pkg)
    }
  }

  clearPackageSelection = () => {
    this.setState({
      selectedPackage: null,
      global_package_id: '',
      packageAvailableDates: [],
      from_date: '',
      to_date: '',
      total_nights: 0,
      calculatedPrice: null,
    })
  }

  isDateInPackage = (day) => {
    if (!this.state.selectedPackage || this.state.packageAvailableDates.length === 0) return true
    const date = moment(this.state.calendarDate).date(day).format('MM/DD/YYYY')
    return this.state.packageAvailableDates.includes(date)
  }

  selectPackageDate = (day) => {
    const date = moment(this.state.calendarDate).date(day).format('YYYY-MM-DD')
    const dateFormatted = moment(date).format('MM/DD/YYYY')

    // Check if date is in past
    if (moment(date).isBefore(moment(), 'day')) {
      return
    }

    const { selectedPackage, packageAvailableDates, chaletSlots } = this.state

    // If package selected, check if date is in package
    if (selectedPackage && !packageAvailableDates.includes(dateFormatted)) {
      return // Silently ignore clicks on unavailable dates
    }

    // If no package selected, check chaletSlots
    if (!selectedPackage && chaletSlots.length > 0) {
      const slot = chaletSlots.find((s) => s.date === date)
      if (!slot || slot.is_disabled) {
        return // Silently ignore clicks on unavailable dates
      }
    }

    // If package has no_of_days, only allow clicking on valid start dates
    if (selectedPackage && selectedPackage.no_of_days) {
      const noOfDays = selectedPackage.no_of_days

      // Check if this can be a valid start date
      if (!this.canBeValidStartDate(date, noOfDays, packageAvailableDates)) {
        return // Silently ignore - this date cannot start a valid range
      }

      const startDate = moment(date)
      // End date is the last day of stay (start + no_of_days - 1)
      // e.g., 4 days starting from 14th = 14, 15, 16, 17 (end date is 17)
      const lastDayOfStay = startDate.clone().add(noOfDays - 1, 'days')

      this.setState(
        {
          from_date: date,
          to_date: lastDayOfStay.format('YYYY-MM-DD'),
          total_nights: noOfDays,
        },
        () => this.calculateChaletPrice()
      )
    } else {
      // No package or no fixed days - manual selection
      const { from_date, to_date } = this.state

      if (!from_date || (from_date && to_date)) {
        // Start new selection
        this.setState({ from_date: date, to_date: '', total_nights: 0, calculatedPrice: null })
      } else {
        // Complete selection
        if (moment(date).isBefore(moment(from_date))) {
          this.setState({ from_date: date, to_date: '', total_nights: 0, calculatedPrice: null })
          return
        }

        this.setState(
          {
            to_date: date,
            total_nights: moment(date).diff(moment(from_date), 'days') + 1,
          },
          () => this.calculateChaletPrice()
        )
      }
    }
  }

  getPackageDateClass = (day) => {
    const date = moment(this.state.calendarDate).date(day).format('YYYY-MM-DD')
    const dateFormatted = moment(date).format('MM/DD/YYYY')
    const { from_date, to_date, selectedPackage, packageAvailableDates, chaletSlots } = this.state

    // Past dates
    if (moment(date).isBefore(moment(), 'day')) {
      return 'disabled'
    }

    // Selected range - all dates from start to end should be highlighted
    if (from_date && to_date) {
      if (moment(date).isSameOrAfter(from_date, 'day') && moment(date).isSameOrBefore(to_date, 'day')) {
        return 'selected'
      }
    } else if (from_date && moment(date).isSame(from_date, 'day')) {
      return 'selected'
    }

    // Package available dates - check if this date can be a valid start date
    if (selectedPackage && packageAvailableDates.length > 0) {
      if (packageAvailableDates.includes(dateFormatted)) {
        // Check if this date can be a valid start date (has enough consecutive days)
        if (selectedPackage.no_of_days) {
          const canBeStartDate = this.canBeValidStartDate(date, selectedPackage.no_of_days, packageAvailableDates)
          return canBeStartDate ? 'available start-valid' : 'available'
        }
        return 'available start-valid'
      }
      return 'unavailable'
    }

    // No package selected - check chaletSlots for availability
    if (chaletSlots.length > 0) {
      const slot = chaletSlots.find((s) => s.date === date)
      if (slot && !slot.is_disabled) {
        return 'available start-valid'
      }
    }

    return 'unavailable'
  }

  // Check if a date can be a valid start date for the package
  canBeValidStartDate = (date, noOfDays, availableDates) => {
    const startDate = moment(date)
    for (let i = 0; i < noOfDays; i++) {
      const checkDate = startDate.clone().add(i, 'days').format('MM/DD/YYYY')
      if (!availableDates.includes(checkDate)) {
        return false
      }
    }
    return true
  }

  confirmPackageSelection = () => {
    if (!this.state.from_date || !this.state.to_date) {
      Swal.fire('Please select check-in and check-out dates', '', 'warning')
      return
    }
    this.setState({ showPackageModal: false }, () => {
      if (this.state.category_id) {
        this.loadChalets(this.state.category_id)
      }
    })
  }

  renderSelectionGrid = (items, selectedId, onSelect, title, emptyMessage, showViewIcon = false) => {
    if (items.length === 0)
      return this.renderEmptyState(
        title === 'Categories' ? 'category' : 'chalet',
        emptyMessage,
        title === 'Categories' ? 'No categories available' : 'Please select a different category'
      )
    return (
      <div className="category-data mt-3">
        {items.map((item) => (
          <div
            key={item.id}
            style={{
              ...this.customStyle.listBox,
              ...(selectedId === item.id ? this.customStyle.listBoxSelected : {}),
              position: 'relative',
            }}
          >
            <div
              onClick={() => onSelect(item)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={
                  item.img_en || item.images?.[0] || item.image
                    ? `${Constant.getImage()}${item.img_en || item.images?.[0] || item.image}`
                    : './assets/images/no_image.png'
                }
                alt={item.name_en || item.name}
                onError={(e) => {
                  e.target.src = './assets/images/no_image.png'
                }}
                style={this.customStyle.listBoxImage}
              />
              {title === 'Categories' ? (
                <p style={this.customStyle.listBoxLabel}>{item.name_en || item.name}</p>
              ) : (
                <>
                  <h4 className="m-0 head-name">{item.chalet_name || item.name_en || item.name}</h4>
                  <p className="m-0 price-data">
                    Starting from {item.chalet_price || 0} {getCurrency(localStorage.getItem('countryShortName'))}
                  </p>
                  <div className="list-details">
                    <div className="entry-data">
                      <img
                        src="./assets/icon/concierge/user.svg"
                        alt=""
                      />
                      <p className="m-0">{item.max_guests || 0} Guests</p>
                    </div>
                    <div className="entry-star">
                      <img
                        src="./assets/icon/concierge/star.svg"
                        alt=""
                      />
                      <p className="m-0">({Number(item.rating || 0).toFixed(2)})</p>
                    </div>
                  </div>
                  <div className="location-data">
                    <img
                      src="./assets/icon/concierge/location.svg"
                      alt=""
                    />
                    <p className="m-0">{item.address || 'N/A'}</p>
                  </div>
                </>
              )}
            </div>
            {showViewIcon && (
              <div
                style={{
                  position: 'absolute',
                  top: 5,
                  right: 5,
                  cursor: 'pointer',
                  background: '#00547e',
                  borderRadius: '50%',
                  width: '30px',
                  height: '30px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 10,
                }}
                onClick={(e) => {
                  e.stopPropagation()
                  this.showChaletDetails(item.id)
                }}
                title="View Details"
              >
                <i
                  className="icofont icofont-eye"
                  style={{ color: 'white', fontSize: '16px' }}
                ></i>
              </div>
            )}
          </div>
        ))}
      </div>
    )
  }

  renderCalendar = () => {
    const canGoBack = moment(this.state.calendarDate).isAfter(moment().startOf('month'), 'month')
    return (
      <div className="booking-box mt-3">
        <div className="month-cal">
          {canGoBack ? (
            <div
              onClick={() => this.changeCalendarMonth(false)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src="./assets/icon/concierge/arrow-prev.svg"
                alt="Previous"
              />
            </div>
          ) : (
            <div></div>
          )}
          <div className="day">{moment(this.state.calendarDate).format('MMMM, YYYY')}</div>
          <div
            onClick={() => this.changeCalendarMonth(true)}
            style={{ cursor: 'pointer' }}
          >
            <img
              src="./assets/icon/concierge/arrow-next.svg"
              alt="Next"
            />
          </div>
        </div>
        <div className="day-list mt-3">
          {['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].map((day) => (
            <span
              key={day}
              className="day-all"
            >
              {day}
            </span>
          ))}
        </div>
        <div className="mt-3 month-data">
          {Array.from({ length: moment(this.state.calendarDate).day() }).map((_, i) => (
            <span key={`empty-${i}`}></span>
          ))}
          {Array.from({ length: moment(this.state.calendarDate).daysInMonth() }).map((_, i) => {
            const price = this.getDatePrice(i + 1)
            const dateClass = this.calendarDateColor(i + 1)
            const isSelected = dateClass.includes('select-blue')
            return (
              <span
                key={i}
                className={`${dateClass} month-date`}
                onClick={() => this.selectCalendarDate(i + 1)}
              >
                <div>{i + 1}</div>
                {price && (
                  <div style={{ fontSize: '10px', fontWeight: '600', color: isSelected ? '#fff' : '#00547e' }}>
                    {price} {getCurrency(localStorage.getItem('countryShortName'))}
                  </div>
                )}
              </span>
            )
          })}
        </div>
        <div
          className="mt-3"
          style={{ display: 'flex', justifyContent: 'space-between', padding: '10px' }}
        >
          <div>
            <strong>Check-in:</strong>{' '}
            {this.state.from_date ? moment(this.state.from_date).format('DD MMM YYYY') : '--'}
          </div>
          <div>
            <strong>Check-out:</strong> {this.state.to_date ? moment(this.state.to_date).format('DD MMM YYYY') : '--'}
          </div>
          <div>
            <strong>Nights:</strong> {this.state.total_nights || 0}
          </div>
        </div>
      </div>
    )
  }

  renderAvailabilityCalendar = () => {
    const {
      packages,
      selectedPackage,
      calendarDate,
      from_date,
      to_date,
      checkInTime,
      checkOutTime,
      calculatedPrice,
      isLoadingPrice,
    } = this.state
    const currency = getCurrency(localStorage.getItem('countryShortName'))
    const canGoBack = moment(calendarDate).isAfter(moment().startOf('month'), 'month')

    // Format time for display
    const formatTime = (time) => {
      if (!time) return ''
      const [hours, minutes] = time.split(':')
      const hour = parseInt(hours)
      const ampm = hour >= 12 ? 'PM' : 'AM'
      const hour12 = hour % 12 || 12
      return `${hour12}:${minutes} ${ampm}`
    }

    return (
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '12px',
          padding: '30px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        }}
      >
        {/* Side by Side Layout: Calendar (Left) | Package Selection (Right) */}
        <div style={{ display: 'flex', gap: '40px', flexWrap: 'wrap' }}>
          {/* Left Side: Calendar */}
          <div style={{ flex: '1 1 350px', minWidth: '300px' }}>
            {/* Month Navigation */}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px' }}>
              {canGoBack ? (
                <div
                  onClick={() => this.changeCalendarMonth(false)}
                  style={{ cursor: 'pointer', padding: '8px 15px' }}
                >
                  <span style={{ color: '#00b4b4', fontSize: '18px', fontWeight: '600' }}>‹</span>
                </div>
              ) : (
                <div style={{ width: '40px' }}></div>
              )}
              <div style={{ color: '#00b4b4', fontSize: '18px', fontWeight: '600', flex: 1, textAlign: 'center' }}>
                {moment(calendarDate).format('MMMM, YYYY')}
              </div>
              <div
                onClick={() => this.changeCalendarMonth(true)}
                style={{ cursor: 'pointer', padding: '8px 15px' }}
              >
                <span style={{ color: '#00b4b4', fontSize: '18px', fontWeight: '600' }}>›</span>
              </div>
            </div>

            {/* Day Headers */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '6px', marginBottom: '6px' }}>
              {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                <div
                  key={day}
                  style={{
                    textAlign: 'center',
                    fontSize: '13px',
                    color: '#1a1a2e',
                    fontWeight: '600',
                    padding: '10px 0',
                  }}
                >
                  {day}
                </div>
              ))}
            </div>

            {/* Calendar Grid - Square cells like the design */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '6px' }}>
              {Array.from({ length: moment(calendarDate).startOf('month').day() }).map((_, i) => (
                <div
                  key={`empty-${i}`}
                  style={{ height: '40px' }}
                ></div>
              ))}
              {Array.from({ length: moment(calendarDate).daysInMonth() }).map((_, i) => {
                const day = i + 1
                const dateClass = this.getPackageDateClass(day)
                const isSelected = dateClass === 'selected'
                const isAvailable = dateClass.includes('available') && !dateClass.includes('unavailable')
                const isValidStartDate = dateClass.includes('start-valid')
                const isDisabled = dateClass === 'disabled'
                const isUnavailable = dateClass === 'unavailable'

                // Block all dates if no package is selected
                const noPackageSelected = !selectedPackage
                const canClick =
                  !noPackageSelected && (isValidStartDate || (!selectedPackage?.no_of_days && isAvailable))

                // Determine background color:
                // - Selected: dark navy
                // - Available (package selected): light blue/teal
                // - Disabled/Unavailable/No package selected: light orange/pink
                let bgColor = '#fce4e4' // Default: disabled (light orange/pink)
                if (isSelected) {
                  bgColor = '#005473' // Selected: dark navy
                } else if (!noPackageSelected && isAvailable) {
                  bgColor = '#d4edda' // Available: light green
                }

                return (
                  <div
                    key={i}
                    onClick={() => canClick && this.selectPackageDate(day)}
                    style={{
                      height: '40px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '8px',
                      cursor: canClick ? 'pointer' : 'default',
                      backgroundColor: bgColor,
                      color: isSelected
                        ? '#fff'
                        : noPackageSelected || isDisabled || isUnavailable
                          ? '#999'
                          : '#1a1a2e',
                      fontSize: '13px',
                      fontWeight: '500',
                      transition: 'all 0.15s ease',
                      opacity:
                        !noPackageSelected && isAvailable && !isValidStartDate && selectedPackage?.no_of_days ? 0.6 : 1,
                      border: isSelected ? 'none' : '1px solid #f0e8e8',
                    }}
                  >
                    {day}
                  </div>
                )
              })}
            </div>
          </div>

          {/* Right Side: Package Selection & Price */}
          <div style={{ flex: '1 1 300px', minWidth: '280px' }}>
            {/* Package Toggles */}
            {packages.length === 0 ? (
              <div
                style={{
                  padding: '40px 20px',
                  textAlign: 'center',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '12px',
                  border: '1px dashed #dee2e6',
                }}
              >
                <div style={{ fontSize: '40px', marginBottom: '15px' }}>📦</div>
                <div style={{ color: '#666', fontSize: '16px', fontWeight: '500' }}>No packages available</div>
                <div style={{ color: '#999', fontSize: '13px', marginTop: '8px' }}>
                  Please select dates from the calendar
                </div>
              </div>
            ) : (
              <div>
                {packages.map((pkg) => {
                  const isSelected = selectedPackage?.id === pkg.id
                  const dayRange = `${pkg.start_day?.charAt(0).toUpperCase() + pkg.start_day?.slice(1)} - ${pkg.end_day?.charAt(0).toUpperCase() + pkg.end_day?.slice(1)}`

                  return (
                    <div
                      key={pkg.id}
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        padding: '18px 0',
                        borderBottom: '1px solid #f0f0f0',
                      }}
                    >
                      {/* Left: Package Name, Day Range & Toggle */}
                      <div style={{ flex: 1 }}>
                        <div style={{ color: '#00b4b4', fontSize: '16px', fontWeight: '600', marginBottom: '4px' }}>
                          {pkg.name}
                        </div>
                        <div style={{ color: '#666', fontSize: '14px', marginBottom: '10px' }}>{dayRange}</div>
                        {/* Toggle Switch */}
                        <div
                          onClick={() => this.togglePackage(pkg)}
                          style={{
                            width: '52px',
                            height: '28px',
                            borderRadius: '14px',
                            backgroundColor: isSelected ? '#00b4b4' : '#e0e0e0',
                            position: 'relative',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s ease',
                          }}
                        >
                          <div
                            style={{
                              position: 'absolute',
                              top: '3px',
                              left: isSelected ? '27px' : '3px',
                              width: '22px',
                              height: '22px',
                              borderRadius: '50%',
                              backgroundColor: '#fff',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                              transition: 'left 0.2s ease',
                            }}
                          />
                        </div>
                      </div>

                      {/* Right: Price & Info */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ color: '#1a1a2e', fontSize: '17px', fontWeight: '600' }}>
                          {pkg.price} {currency}
                        </span>
                        {/* <span style={{ color: '#ccc', fontSize: '16px', cursor: 'pointer' }}>ⓘ</span> */}
                      </div>
                    </div>
                  )
                })}
              </div>
            )}

            {/* Check-in/Check-out Details & Price - Below Package Selection */}
            {from_date && to_date && (
              <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: '20px', marginTop: '10px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                  {/* Check-In */}
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                      {/* <span style={{ color: '#00b4b4', fontSize: '12px' }}>📍</span> */}
                      <span style={{ color: '#00b4b4', fontSize: '14px', fontWeight: '600' }}>Check-In</span>
                    </div>
                    <div style={{ color: '#1a1a2e', fontSize: '14px', fontWeight: '500' }}>
                      {moment(from_date).format('dddd, D MMMM')}
                    </div>
                    {checkInTime && (
                      <div style={{ color: '#00b4b4', fontSize: '12px', marginTop: '2px' }}>
                        Begins at {formatTime(checkInTime)}
                      </div>
                    )}
                  </div>

                  {/* Check-Out */}
                  <div style={{ textAlign: 'right' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        marginBottom: '4px',
                        justifyContent: 'flex-end',
                      }}
                    >
                      {/* <span style={{ color: '#00547e', fontSize: '12px' }}>🧳</span> */}
                      <span style={{ color: '#00547e', fontSize: '14px', fontWeight: '600' }}>Check-Out</span>
                    </div>
                    <div style={{ color: '#1a1a2e', fontSize: '14px', fontWeight: '500' }}>
                      {moment(to_date).format('dddd, D MMMM')}
                    </div>
                    {checkOutTime && (
                      <div style={{ color: '#666', fontSize: '12px', marginTop: '2px' }}>
                        Is by {formatTime(checkOutTime)}
                      </div>
                    )}
                  </div>
                </div>

                {/* Price For Chalet */}
                {isLoadingPrice ? (
                  <div style={{ marginTop: '10px' }}>
                    <div
                      style={{
                        display: 'inline-block',
                        width: '18px',
                        height: '18px',
                        border: '2px solid #00b4b4',
                        borderTop: '2px solid transparent',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                      }}
                    />
                  </div>
                ) : (
                  calculatedPrice && (
                    <div style={{ marginTop: '10px' }}>
                      <div style={{ color: '#666', fontSize: '13px' }}>Price For Chalet</div>
                      <div style={{ color: '#00b4b4', fontSize: '22px', fontWeight: '700' }}>
                        {calculatedPrice.price} {currency}
                      </div>
                    </div>
                  )
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  renderGuestCounter = () => (
    <div className="counter-container">
      <div className="counter-label">Guests</div>
      <div className="counter-buttons">
        <button
          className="counter-button decrement"
          onClick={this.decrementGuest}
        >
          -
        </button>
        <div className="count">{this.state.guestCount}</div>
        <button
          className="counter-button increment"
          onClick={this.incrementGuest}
        >
          +
        </button>
      </div>
      <div className="priceE">Max: {this.state.maxGuests}</div>
    </div>
  )

  renderGlobalPackageModal = () => {
    if (!this.state.showGlobalPackageModal) return null

    const { globalPackageList, selectedGlobalPackage, globalPackageCalendarDate, from_date, to_date, isCheckingAvailability } = this.state
    const canGoBack = moment(globalPackageCalendarDate).isAfter(moment().startOf('month'), 'month')

    return (
      <div className="popup-backdrop" onClick={this.closeGlobalPackageModal}>
        <div
          className="popup-content"
          onClick={(e) => e.stopPropagation()}
          style={{
            width: '90%',
            maxWidth: '500px',
            padding: '30px',
            position: 'relative',
            maxHeight: '90vh',
            overflow: 'auto',
            borderRadius: '16px',
          }}
        >
          <button
            className="popup-close"
            onClick={this.closeGlobalPackageModal}
            style={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              zIndex: 1000,
              background: '#00547e',
              borderRadius: '50%',
              width: '30px',
              height: '30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            <span style={{ color: '#fff', fontSize: '18px', lineHeight: 1 }}>×</span>
          </button>

          {/* Modal Header */}
          <div style={{ textAlign: 'center', marginBottom: '25px' }}>
            <h2 style={{ margin: '0 0 8px 0', fontSize: '22px', fontWeight: '700', color: '#00547e' }}>
              Select from & To date
            </h2>
            <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
              Select Your Preferred package, Then Choose a Date
            </p>
          </div>

          {/* Package Tabs */}
          <div style={{ display: 'flex', gap: '10px', marginBottom: '25px', flexWrap: 'wrap' }}>
            {globalPackageList.map((pkg) => {
              const isSelected = selectedGlobalPackage?.id === pkg.id
              return (
                <button
                  key={pkg.id}
                  onClick={() => this.selectGlobalPackage(pkg)}
                  style={{
                    padding: '10px 20px',
                    borderRadius: '25px',
                    border: isSelected ? 'none' : '1px solid #ddd',
                    backgroundColor: isSelected ? '#00547e' : '#fff',
                    color: isSelected ? '#fff' : '#333',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                  }}
                >
                  {pkg.name}
                </button>
              )
            })}
          </div>

          {/* Calendar */}
          <div style={{ marginBottom: '25px' }}>
            {/* Month Navigation */}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px' }}>
              {canGoBack ? (
                <div
                  onClick={() => this.changeGlobalPackageCalendarMonth(false)}
                  style={{ cursor: 'pointer', padding: '8px 15px' }}
                >
                  <span style={{ color: '#00b4b4', fontSize: '18px', fontWeight: '600' }}>‹</span>
                </div>
              ) : (
                <div style={{ width: '40px' }}></div>
              )}
              <div style={{ color: '#00b4b4', fontSize: '18px', fontWeight: '600', flex: 1, textAlign: 'center' }}>
                {moment(globalPackageCalendarDate).format('MMMM, YYYY')}
              </div>
              <div
                onClick={() => this.changeGlobalPackageCalendarMonth(true)}
                style={{ cursor: 'pointer', padding: '8px 15px' }}
              >
                <span style={{ color: '#00b4b4', fontSize: '18px', fontWeight: '600' }}>›</span>
              </div>
            </div>

            {/* Day Headers */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '6px', marginBottom: '6px' }}>
              {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                <div
                  key={day}
                  style={{
                    textAlign: 'center',
                    fontSize: '13px',
                    color: '#1a1a2e',
                    fontWeight: '600',
                    padding: '10px 0',
                  }}
                >
                  {day}
                </div>
              ))}
            </div>

            {/* Calendar Grid */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '6px' }}>
              {Array.from({ length: moment(globalPackageCalendarDate).startOf('month').day() }).map((_, i) => (
                <div key={`empty-${i}`} style={{ height: '40px' }}></div>
              ))}
              {Array.from({ length: moment(globalPackageCalendarDate).daysInMonth() }).map((_, i) => {
                const day = i + 1
                const dateClass = this.getGlobalPackageDateClass(day)
                const isSelected = dateClass === 'selected'
                const isAvailable = dateClass.includes('available')
                const isValidStart = dateClass.includes('start-valid')
                const isDisabled = dateClass === 'disabled'
                const isUnavailable = dateClass === 'unavailable'

                const canClick = isValidStart || (isAvailable && !selectedGlobalPackage?.no_of_days)

                let bgColor = '#fce4e4' // Default: unavailable (light pink)
                if (isSelected) {
                  bgColor = '#005473' // Selected: dark navy
                } else if (isAvailable) {
                  bgColor = '#d4edda' // Available: pale green
                }

                return (
                  <div
                    key={i}
                    onClick={() => canClick && this.selectGlobalPackageDate(day)}
                    style={{
                      height: '40px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '8px',
                      cursor: canClick ? 'pointer' : 'default',
                      backgroundColor: bgColor,
                      color: isSelected ? '#fff' : isDisabled || isUnavailable ? '#999' : '#1a1a2e',
                      fontSize: '14px',
                      fontWeight: '500',
                      transition: 'all 0.15s ease',
                      opacity: isAvailable && !isValidStart && selectedGlobalPackage?.no_of_days ? 0.6 : 1,
                    }}
                  >
                    {day}
                  </div>
                )
              })}
            </div>
          </div>

          {/* Selected Dates Display */}
          {from_date && to_date && (
            <div style={{
              textAlign: 'center',
              marginBottom: '20px',
              padding: '15px',
              backgroundColor: '#f8f9fa',
              borderRadius: '10px'
            }}>
              <span style={{ color: '#00547e', fontWeight: '600' }}>
                {moment(from_date).format('MMM DD, YYYY')} - {moment(to_date).format('MMM DD, YYYY')}
              </span>
            </div>
          )}

          {/* Proceed Button */}
          <button
            onClick={this.proceedWithGlobalPackage}
            disabled={!from_date || !to_date || isCheckingAvailability}
            style={{
              width: '100%',
              padding: '15px',
              borderRadius: '10px',
              border: 'none',
              backgroundColor: (!from_date || !to_date) ? '#ccc' : '#00547e',
              color: '#fff',
              fontSize: '16px',
              fontWeight: '600',
              cursor: (!from_date || !to_date || isCheckingAvailability) ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s ease',
            }}
          >
            {isCheckingAvailability ? 'Checking Availability...' : 'Proceed'}
          </button>
        </div>
      </div>
    )
  }

  renderPaymentConfirmationModal = () => {
    if (!this.state.showPaymentModal) return null
    const { bookingData } = this.state
    const currency = getCurrency(localStorage.getItem('countryShortName'))
    const checkInDate = bookingData?.start_date ? moment(bookingData.start_date).format('dddd, D MMMM') : '--'
    const checkOutDate = bookingData?.end_date ? moment(bookingData.end_date).format('dddd, D MMMM') : '--'
    const checkInTime = bookingData?.check_in_time
      ? moment(bookingData.check_in_time, 'HH:mm:ss').format('hh:mm A')
      : ''
    const checkOutTime = bookingData?.check_out_time
      ? moment(bookingData.check_out_time, 'HH:mm:ss').format('hh:mm A')
      : ''

    return (
      <div className="App">
        <div
          className="popup-backdrop"
          onClick={this.closePaymentModal}
        >
          <div
            className="popup-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '90%',
              maxWidth: '600px',
              padding: '25px',
              position: 'relative',
              maxHeight: '90vh',
              overflow: 'auto',
            }}
          >
            <button
              className="popup-close"
              onClick={this.closePaymentModal}
              style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 1000 }}
            >
              <img
                src="./assets/icon/concierge/close-black.svg"
                alt="Close"
              />
            </button>
            <h2
              style={{ margin: '0 0 20px 0', fontSize: '20px', fontWeight: '600', color: '#333', textAlign: 'center' }}
            >
              Payment Confirmation
            </h2>
            <div
              style={{
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                padding: '15px 20px',
                marginBottom: '20px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div style={{ textAlign: 'left' }}>
                <p style={{ margin: '0 0 5px 0', fontSize: '13px', color: '#666' }}>Check-in</p>
                <p style={{ margin: '0', fontSize: '13px', color: '#00547e' }}>{checkInDate}</p>
                {checkInTime && <span style={{ fontSize: '12px', color: '#999' }}>{checkInTime}</span>}
              </div>
              <div style={{ textAlign: 'center' }}>
                {bookingData?.chalet_image && (
                  <img
                    src={Constant.getImage() + bookingData.chalet_image}
                    alt={bookingData?.chalet_name || 'Chalet'}
                    style={{
                      width: '60px',
                      height: '60px',
                      objectFit: 'cover',
                      borderRadius: '8px',
                      marginBottom: '5px',
                    }}
                    onError={({ currentTarget }) => {
                      currentTarget.style.display = 'none'
                    }}
                  />
                )}
                <h5 style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#00547e' }}>
                  {bookingData?.chalet_name || '--'}
                </h5>
              </div>
              <div style={{ textAlign: 'right' }}>
                <p style={{ margin: '0 0 5px 0', fontSize: '13px', color: '#666' }}>Check-out</p>
                <p style={{ margin: '0', fontSize: '13px', color: '#00547e' }}>{checkOutDate}</p>
                {checkOutTime && <span style={{ fontSize: '12px', color: '#999' }}>{checkOutTime}</span>}
              </div>
            </div>
            <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', padding: '20px' }}>
              <h3 style={{ margin: '0 0 20px 0', fontSize: '16px', fontWeight: '600', color: '#333' }}>
                Payment Summary
              </h3>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '12px 0',
                  borderBottom: '1px solid #f0f0f0',
                }}
              >
                <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>Chalet Amount</p>
                <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                  {bookingData?.paymentSummary?.chalet_amount || 0} {currency}
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '12px 0',
                  borderBottom: '1px solid #f0f0f0',
                }}
              >
                <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>Cost Of Service</p>
                <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                  {bookingData?.paymentSummary?.cost_of_service || 0} {currency}
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '12px 0',
                  borderBottom: '1px solid #f0f0f0',
                }}
              >
                <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>Coupon Applied</p>
                <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                  {bookingData?.paymentSummary?.coupon_applied_amount || 0} {currency}
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '12px 0',
                  borderBottom: '1px solid #f0f0f0',
                }}
              >
                <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
                  VAT ({bookingData?.paymentSummary?.vat || 0}%)
                </p>
                <span style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                  {bookingData?.paymentSummary?.vat_amount || 0} {currency}
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '15px 0 0 0' }}>
                <p style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#333' }}>Total</p>
                <span style={{ fontSize: '16px', fontWeight: '700', color: '#00547e' }}>
                  {bookingData?.paymentSummary?.total_booking_amount || 0} {currency}
                </span>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '15px', marginTop: '20px' }}>
              <button
                onClick={this.closePaymentModal}
                style={{
                  flex: 1,
                  padding: '12px',
                  backgroundColor: '#fff',
                  color: '#d33',
                  border: '1px solid #d33',
                  borderRadius: '8px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  this.processPayment()
                }}
                disabled={this.state.isBooking}
                style={{
                  flex: 2,
                  padding: '12px',
                  backgroundColor: this.state.isBooking ? '#6c9ab5' : '#00547e',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: this.state.isBooking ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                }}
              >
                {this.state.isBooking && (
                  <div
                    style={{
                      width: 18,
                      height: 18,
                      border: '2px solid #fff',
                      borderTop: '2px solid transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                    }}
                  />
                )}
                {this.state.isBooking
                  ? 'Processing...'
                  : `Process Payment ${bookingData?.paymentSummary?.total_booking_amount || 0} ${currency}`}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderPackageSelectionModal = () => {
    if (!this.state.showPackageModal) return null
    const { globalPackageList, selectedPackage, calendarDate, from_date, to_date } = this.state
    const canGoBack = moment(calendarDate).isAfter(moment().startOf('month'), 'month')

    return (
      <div className="App">
        <div
          className="popup-backdrop"
          onClick={this.closePackageModal}
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
          <div
            className="popup-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '90%',
              maxWidth: '420px',
              padding: '30px 25px',
              position: 'relative',
              borderRadius: '20px',
              backgroundColor: '#fff',
              boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
            }}
          >
            {/* Close Button */}
            <button
              className="popup-close"
              onClick={this.closePackageModal}
              style={{
                position: 'absolute',
                top: '-12px',
                right: '-12px',
                zIndex: 1000,
                background: '#00b4b4',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: 'none',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              }}
            >
              <span style={{ color: 'white', fontSize: '18px', fontWeight: 'bold', lineHeight: 1 }}>×</span>
            </button>

            {/* Header */}
            <h2
              style={{
                margin: '0 0 8px 0',
                fontSize: '22px',
                fontWeight: '700',
                color: '#1a1a2e',
                textAlign: 'center',
              }}
            >
              Select from & To date
            </h2>
            <p style={{ margin: '0 0 24px 0', fontSize: '14px', color: '#666', textAlign: 'center' }}>
              Select Your Preferred package, Then Choose a Date
            </p>

            {/* Package Tabs */}
            <div
              style={{ display: 'flex', gap: '8px', justifyContent: 'center', marginBottom: '24px', flexWrap: 'wrap' }}
            >
              {globalPackageList.map((pkg) => (
                <button
                  key={pkg.id}
                  onClick={() => this.selectPackage(pkg)}
                  style={{
                    padding: '10px 22px',
                    borderRadius: '25px',
                    border: selectedPackage?.id === pkg.id ? 'none' : '1px solid #e0e0e0',
                    backgroundColor: selectedPackage?.id === pkg.id ? '#00446e' : '#fff',
                    color: selectedPackage?.id === pkg.id ? '#fff' : '#333',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: selectedPackage?.id === pkg.id ? '0 2px 8px rgba(0,68,110,0.3)' : 'none',
                  }}
                >
                  {pkg.name}
                </button>
              ))}
            </div>

            {/* Calendar */}
            <div style={{ marginBottom: '20px' }}>
              {/* Month Navigation */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: '20px',
                  gap: '20px',
                }}
              >
                {canGoBack ? (
                  <div
                    onClick={() => this.changeCalendarMonth(false)}
                    style={{ cursor: 'pointer', padding: '5px 10px', opacity: 0.6 }}
                  >
                    <span style={{ color: '#00b4b4', fontSize: '18px', fontWeight: '600' }}>‹</span>
                  </div>
                ) : (
                  <div style={{ width: '30px' }}></div>
                )}
                <div style={{ color: '#00b4b4', fontSize: '18px', fontWeight: '600' }}>
                  {moment(calendarDate).format('MMMM, YYYY')}
                </div>
                <div
                  onClick={() => this.changeCalendarMonth(true)}
                  style={{ cursor: 'pointer', padding: '5px 10px' }}
                >
                  <span style={{ color: '#00b4b4', fontSize: '18px', fontWeight: '600' }}>›</span>
                </div>
              </div>

              {/* Day Headers */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px', marginBottom: '12px' }}>
                {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                  <div
                    key={day}
                    style={{
                      textAlign: 'center',
                      fontSize: '13px',
                      color: '#1a1a2e',
                      fontWeight: '600',
                      padding: '8px 0',
                    }}
                  >
                    {day}
                  </div>
                ))}
              </div>

              {/* Calendar Grid */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px' }}>
                {Array.from({ length: moment(calendarDate).startOf('month').day() }).map((_, i) => (
                  <div
                    key={`empty-${i}`}
                    style={{ height: '44px' }}
                  ></div>
                ))}
                {Array.from({ length: moment(calendarDate).daysInMonth() }).map((_, i) => {
                  const day = i + 1
                  const dateClass = this.getPackageDateClass(day)
                  const isSelected = dateClass === 'selected'
                  const isAvailable = dateClass.includes('available') && !dateClass.includes('unavailable')
                  const isValidStartDate = dateClass.includes('start-valid')
                  const isDisabled = dateClass === 'disabled'
                  const isUnavailable = dateClass === 'unavailable'
                  const canClick = isValidStartDate || (!selectedPackage?.no_of_days && isAvailable)

                  return (
                    <div
                      key={i}
                      onClick={() => canClick && this.selectPackageDate(day)}
                      style={{
                        width: '44px',
                        height: '44px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '50%',
                        cursor: isDisabled || isUnavailable || (!canClick && !isSelected) ? 'default' : 'pointer',
                        // Selected: dark navy, Available (can be start): light pink, Available (not start): lighter pink, Unavailable/Disabled: transparent
                        backgroundColor: isSelected
                          ? '#005473'
                          : isAvailable
                            ? 'rgba(0, 84, 115, 0.15)'
                            : isDisabled || isUnavailable
                              ? '#fce4e4'
                              : 'transparent',
                        color: isSelected ? '#fff' : isDisabled || isUnavailable ? '#d0d0d0' : '#1a1a2e',
                        fontSize: '15px',
                        fontWeight: isSelected ? '600' : '500',
                        transition: 'all 0.15s ease',
                        margin: '0 auto',
                        opacity: isAvailable && !isValidStartDate && selectedPackage?.no_of_days ? 0.6 : 1,
                      }}
                    >
                      {day}
                    </div>
                  )
                })}
              </div>
            </div>

            {/* Proceed Button */}
            <button
              onClick={this.confirmPackageSelection}
              disabled={!from_date || !to_date}
              style={{
                width: '100%',
                padding: '14px',
                backgroundColor: !from_date || !to_date ? '#ccc' : '#00446e',
                color: '#fff',
                border: 'none',
                borderRadius: '25px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: !from_date || !to_date ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                boxShadow: !from_date || !to_date ? 'none' : '0 4px 12px rgba(0,68,110,0.3)',
              }}
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    )
  }

  renderChaletDetailsModal = () => {
    if (!this.state.showDetailsModal) return null
    if (this.state.isLoadingChaletDetails)
      return (
        <div className="App">
          <div
            className="popup-backdrop"
            onClick={this.closeChaletDetails}
          >
            <div
              className="popup-content"
              onClick={(e) => e.stopPropagation()}
              style={{
                width: '90%',
                maxWidth: '800px',
                padding: '50px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '16px',
              }}
            >
              {this.renderInlineLoader(150)}
            </div>
          </div>
        </div>
      )
    if (!this.state.chaletDetails) return null
    const details = this.state.chaletDetails
    const gallary = details.chalet_gallary || details.gallary || []
    const facilities = details.chalet_facilities_details || details.facilities || []
    const { selectedImageIndex } = this.state
    const displayedFacilities = facilities
    const chaletName = details.chalet_name || details.name_en || 'Chalet'
    const chaletImage = details.img || details.image
    const address = details.address_en || details.address
    const addressDetails = details.address_details_en || details.address_details
    const description = details.desc_en || details.description
    const rating = details.avgRating ? parseFloat(details.avgRating).toFixed(1) : '0'

    // Get current main image
    const getMainImage = () => {
      if (gallary.length > 0 && selectedImageIndex < gallary.length) {
        return gallary[selectedImageIndex]?.img || gallary[selectedImageIndex]?.gal_large_img
      }
      return chaletImage
    }

    return (
      <div className="App">
        <div
          className="popup-backdrop"
          onClick={this.closeChaletDetails}
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
          <div
            className="popup-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '90%',
              maxWidth: '800px',
              maxHeight: '90vh',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'visible',
              padding: '25px',
              position: 'relative',
              borderRadius: '16px',
            }}
          >
            {/* Close Button */}
            <button
              className="popup-close"
              onClick={this.closeChaletDetails}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                zIndex: 1000,
                background: '#00b4b4',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: 'none',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              }}
            >
              <span style={{ color: 'white', fontSize: '18px', fontWeight: 'bold', lineHeight: 1 }}>×</span>
            </button>

            <div
              style={{ overflowY: 'auto', maxHeight: 'calc(90vh - 50px)', width: '100%' }}
              className="scroll"
            >
              <div style={{ display: 'flex', gap: '25px', flexWrap: 'wrap' }}>
                {/* Left Side - Image Gallery */}
                <div style={{ flex: '0 0 auto', width: '320px', minWidth: '280px' }}>
                  {/* Main Image */}
                  {(chaletImage || gallary.length > 0) && (
                    <div style={{ marginBottom: '15px', position: 'relative' }}>
                      <img
                        src={`${Constant.getImage()}${getMainImage()}`}
                        alt={chaletName}
                        style={{ width: '100%', height: '250px', objectFit: 'cover', borderRadius: '12px' }}
                        onError={(e) => {
                          e.target.src = './assets/images/no_image.png'
                        }}
                      />
                      {/* Navigation Arrows */}
                      {gallary.length > 1 && (
                        <>
                          <button
                            onClick={() =>
                              this.setState({
                                selectedImageIndex:
                                  selectedImageIndex > 0 ? selectedImageIndex - 1 : gallary.length - 1,
                              })
                            }
                            style={{
                              position: 'absolute',
                              left: '10px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              background: 'rgba(255,255,255,0.9)',
                              border: 'none',
                              borderRadius: '50%',
                              width: '32px',
                              height: '32px',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '16px',
                              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                            }}
                          >
                            ‹
                          </button>
                          <button
                            onClick={() =>
                              this.setState({
                                selectedImageIndex:
                                  selectedImageIndex < gallary.length - 1 ? selectedImageIndex + 1 : 0,
                              })
                            }
                            style={{
                              position: 'absolute',
                              right: '10px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              background: 'rgba(255,255,255,0.9)',
                              border: 'none',
                              borderRadius: '50%',
                              width: '32px',
                              height: '32px',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '16px',
                              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                            }}
                          >
                            ›
                          </button>
                        </>
                      )}
                    </div>
                  )}
                  {/* Thumbnail Gallery */}
                  {gallary.length > 1 && (
                    <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '10px' }}>
                      {gallary.slice(0, 6).map((img, index) => (
                        <img
                          key={img.id || index}
                          src={`${Constant.getImage()}${img.thumb_img || img.gal_thumb_img}`}
                          alt={`${chaletName} - ${index + 1}`}
                          onClick={() => this.setState({ selectedImageIndex: index })}
                          style={{
                            width: '60px',
                            height: '60px',
                            objectFit: 'cover',
                            borderRadius: '8px',
                            border: selectedImageIndex === index ? '2px solid #00b4b4' : '2px solid transparent',
                            cursor: 'pointer',
                            transition: 'border 0.2s ease',
                          }}
                          onError={(e) => {
                            e.target.src = './assets/images/no_image.png'
                          }}
                        />
                      ))}
                      {gallary.length > 6 && (
                        <div
                          onClick={() => this.setState({ selectedImageIndex: 6 })}
                          style={{
                            width: '60px',
                            height: '60px',
                            borderRadius: '8px',
                            backgroundColor: '#f0f0f0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '12px',
                            color: '#666',
                            cursor: 'pointer',
                          }}
                        >
                          +{gallary.length - 6}
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Right Side - Details */}
                <div style={{ flex: '1 1 300px', minWidth: '280px' }}>
                  {/* Title & Rating */}
                  <h2 style={{ margin: '0 0 5px 0', fontSize: '24px', fontWeight: '700', color: '#1a1a2e' }}>
                    {chaletName}
                  </h2>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                    <div style={{ display: 'flex', gap: '2px' }}>
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span
                          key={star}
                          style={{
                            color: star <= Math.round(details.avgRating || 0) ? '#ffc107' : '#ddd',
                            fontSize: '14px',
                          }}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                    <span style={{ color: '#00b4b4', fontSize: '13px' }}>{rating} review</span>
                  </div>

                  {/* Location */}
                  {address && (
                    <div style={{ marginBottom: '15px' }}>
                      <div style={{ fontSize: '13px', color: '#666' }}>
                        Pick up point: <span style={{ color: '#00b4b4' }}>📍 {address}</span>
                      </div>
                      {addressDetails && <div style={{ fontSize: '13px', color: '#666' }}>{addressDetails}</div>}
                    </div>
                  )}

                  {/* Property Stats Grid */}
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(2, 1fr)',
                      gap: '10px',
                      marginBottom: '20px',
                    }}
                  >
                    <div
                      style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '10px',
                        padding: '12px',
                        textAlign: 'center',
                      }}
                    >
                      <div style={{ fontSize: '20px', marginBottom: '5px' }}>👤</div>
                      <div style={{ fontSize: '13px', color: '#1a1a2e', fontWeight: '500' }}>
                        {details.max_guests || 0} Guests
                      </div>
                    </div>
                    <div
                      style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '10px',
                        padding: '12px',
                        textAlign: 'center',
                      }}
                    >
                      <div style={{ fontSize: '20px', marginBottom: '5px' }}>🛋️</div>
                      <div style={{ fontSize: '13px', color: '#1a1a2e', fontWeight: '500' }}>
                        {details.lounges || 0} Big lounges
                      </div>
                    </div>
                    <div
                      style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '10px',
                        padding: '12px',
                        textAlign: 'center',
                      }}
                    >
                      <div style={{ fontSize: '20px', marginBottom: '5px' }}>🛏️</div>
                      <div style={{ fontSize: '13px', color: '#1a1a2e', fontWeight: '500' }}>
                        {details.bedrooms || 0} Bedrooms
                      </div>
                    </div>
                    <div
                      style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '10px',
                        padding: '12px',
                        textAlign: 'center',
                      }}
                    >
                      <div style={{ fontSize: '20px', marginBottom: '5px' }}>🚿</div>
                      <div style={{ fontSize: '13px', color: '#1a1a2e', fontWeight: '500' }}>
                        {details.bathrooms || 0} Bathrooms
                      </div>
                    </div>
                  </div>

                  {/* Comfort Facilities */}
                  {facilities.length > 0 && (
                    <div style={{ marginBottom: '20px' }}>
                      <h4 style={{ fontSize: '15px', fontWeight: '600', color: '#1a1a2e', marginBottom: '12px' }}>
                        Comfort Facilities
                      </h4>
                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                        {displayedFacilities.map((facility, index) => (
                          <div
                            key={facility.id || index}
                            style={{
                              border: '1px solid #e0e0e0',
                              borderRadius: '8px',
                              padding: '8px 12px',
                              textAlign: 'center',
                              minWidth: '60px',
                              backgroundColor: '#fafafa',
                            }}
                          >
                            {facility.image && (
                              <img
                                src={`${Constant.getImage()}${facility.image}`}
                                alt={facility.name || facility.name_en}
                                style={{ width: '20px', height: '20px', marginBottom: '4px' }}
                                onError={(e) => {
                                  e.target.style.display = 'none'
                                }}
                              />
                            )}
                            <div
                              style={{
                                fontSize: '10px',
                                color: '#666',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '70px',
                              }}
                            >
                              {facility.name || facility.name_en}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Select Button */}
                  <button
                    onClick={() => {
                      this.closeChaletDetails()
                      this.setState({ chalet_id: details.id, maxGuests: details.max_guests || 10 }, () =>
                        this.loadChaletAvailability(details.id)
                      )
                    }}
                    style={{
                      width: '100%',
                      padding: '14px',
                      backgroundColor: '#00446e',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      cursor: 'pointer',
                      marginBottom: '20px',
                    }}
                  >
                    Select
                  </button>
                </div>
              </div>

              {/* Description Section */}
              {description && (
                <div style={{ marginTop: '20px', borderTop: '1px solid #e0e0e0', paddingTop: '20px' }}>
                  <h4
                    style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#00547e',
                      marginBottom: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    Description
                    <span style={{ color: '#ccc', cursor: 'pointer' }}>›</span>
                  </h4>
                  <div
                    style={{ fontSize: '14px', color: '#666', lineHeight: '1.6' }}
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                </div>
              )}

              {/* Check-in/Check-out Times */}
              {(details.check_in_time || details.check_out_time) && (
                <div style={{ marginTop: '15px', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  {details.check_in_time && (
                    <div
                      style={{
                        flex: '1',
                        minWidth: '140px',
                        padding: '12px 16px',
                        backgroundColor: '#e8f5e9',
                        borderRadius: '10px',
                        borderLeft: '4px solid #4caf50',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '11px',
                          color: '#666',
                          marginBottom: '4px',
                          textTransform: 'uppercase',
                          fontWeight: '600',
                        }}
                      >
                        Check-in
                      </div>
                      <div style={{ fontSize: '15px', color: '#1a1a2e', fontWeight: '600' }}>
                        {details.check_in_time}
                      </div>
                    </div>
                  )}
                  {details.check_out_time && (
                    <div
                      style={{
                        flex: '1',
                        minWidth: '140px',
                        padding: '12px 16px',
                        backgroundColor: '#ffebee',
                        borderRadius: '10px',
                        borderLeft: '4px solid #f44336',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '11px',
                          color: '#666',
                          marginBottom: '4px',
                          textTransform: 'uppercase',
                          fontWeight: '600',
                        }}
                      >
                        Check-out
                      </div>
                      <div style={{ fontSize: '15px', color: '#1a1a2e', fontWeight: '600' }}>
                        {details.check_out_time}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { isLoading, initialLoading } = this.state
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane active"
                        role="tabpanel"
                      >
                        {(isLoading || initialLoading) && (
                          <div className="loader-overlay">
                            <div className="loader"></div>
                          </div>
                        )}
                        <div>
                          <div
                            style={{
                              marginBottom: 25,
                              paddingBottom: 15,
                              border: '2px solid #00547e',
                              padding: '10px 20px',
                              borderRadius: '10px',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              alignContent: 'center',
                            }}
                          >
                            <h1
                              style={{
                                fontSize: '26px',
                                fontWeight: '700',
                                color: '#00547e',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                margin: 0,
                              }}
                            >
                              <i
                                className="icofont icofont-calendar"
                                style={{ marginRight: '10px', fontSize: '28px' }}
                              ></i>
                              Chalet Booking
                            </h1>
                          </div>

                          {/* Categories Section */}
                          <div className="card-padding mb-3">
                            <div className="yacht-title mb-1">
                              <h2 className="text-heading">Select Category</h2>
                              <div className="contact-in contact-second">
                                <div>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="chalet_search"
                                    id="chalet_search"
                                    placeholder="Search chalets"
                                    onChange={this.handleChaletSearch}
                                    value={this.state.chalet_search}
                                    style={{ borderRadius: '10px' }}
                                  />
                                </div>
                                <div className="position-relative filter-width">
                                  <div
                                    className="filter"
                                    onClick={() => this.setState({ filterOpen: !this.state.filterOpen })}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <img
                                      src="./assets/icon/concierge/filter-icon.svg"
                                      alt="Filter"
                                    />
                                    <p className="m-0">Filter</p>
                                    {this.state.filterCount > 0 && (
                                      <span className="filter-count-indicator">{this.state.filterCount}</span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {this.state.isLoadingCategories
                              ? this.renderInlineLoader(120)
                              : this.renderSelectionGrid(
                                this.state.categoryList,
                                this.state.category_id,
                                (cat) => {
                                  this.setState({ category_id: cat.id })
                                  this.loadChalets(cat.id)
                                },
                                'Categories',
                                'No categories available'
                              )}
                          </div>

                          {/* Filter Popup */}
                          {this.state.filterOpen && (
                            <div
                              className="popup-backdrop"
                              onClick={() => this.setState({ filterOpen: false })}
                            >
                              <div
                                className="popup-content filter-popup-content"
                                onClick={(e) => e.stopPropagation()}
                                style={{ maxWidth: '400px', padding: '25px' }}
                              >
                                <button
                                  className="popup-close"
                                  onClick={() => this.setState({ filterOpen: false })}
                                >
                                  <img
                                    src="./assets/icon/concierge/close-black.svg"
                                    alt="Close"
                                  />
                                </button>
                                <div className="popupScroll">
                                  <div className="filter-popup-header">
                                    <div className="filter-icon-header">
                                      <img
                                        src="./assets/icon/concierge/filter-icon.svg"
                                        alt="Filter"
                                        className="filter-main-icon"
                                      />
                                    </div>
                                    <h2 className="text-heading filter-main-title">Filter Options</h2>
                                    <p className="filter-subtitle">Refine your search to find the perfect chalet</p>
                                  </div>

                                  <div className="filter-sections" style={{ marginTop: '20px' }}>
                                    {/* Check-In / Check-Out Section */}
                                    <div style={{ marginBottom: '20px' }}>
                                      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                        <div
                                          onClick={this.openGlobalPackageModal}
                                          style={{
                                            flex: 1,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                            padding: '12px 15px',
                                            border: '2px solid #00547e',
                                            borderRadius: '10px',
                                            cursor: 'pointer',
                                            backgroundColor: '#fff',
                                          }}
                                        >
                                          {this.state.from_date && this.state.to_date ? (
                                            <span style={{ color: '#00547e', fontWeight: '600', fontSize: '14px' }}>
                                              {moment(this.state.from_date).format('MMM DD')} - {moment(this.state.to_date).format('MMM DD, YYYY')}
                                            </span>
                                          ) : (
                                            <>
                                              <span style={{ color: '#666', fontSize: '14px' }}>Check-In</span>
                                              <span style={{ color: '#00547e', fontSize: '14px' }}>▸</span>
                                              <span style={{ color: '#666', fontSize: '14px' }}>Check-Out</span>
                                            </>
                                          )}
                                        </div>
                                        <button
                                          onClick={this.clearDateSelection}
                                          style={{
                                            padding: '12px 20px',
                                            backgroundColor: '#00547e',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '10px',
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                          }}
                                        >
                                          Clear
                                        </button>
                                      </div>
                                      {this.state.selectedGlobalPackage && (
                                        <div style={{ marginTop: '8px', fontSize: '12px', color: '#00547e' }}>
                                          <strong>Package:</strong> {this.state.selectedGlobalPackage.name}
                                        </div>
                                      )}
                                    </div>

                                    {/* No of Guest */}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 0', borderBottom: '1px solid #eee' }}>
                                      <span style={{ fontSize: '15px', fontWeight: '500', color: '#333' }}>No of guest</span>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                        <button
                                          onClick={() => this.decrementFilter('filterGuests')}
                                          style={{ width: '30px', height: '30px', border: '1px solid #00547e', borderRadius: '6px', background: '#fff', color: '#00547e', fontSize: '18px', cursor: 'pointer' }}
                                        >−</button>
                                        <span style={{ minWidth: '20px', textAlign: 'center', fontSize: '15px' }}>{this.state.filterGuests}</span>
                                        <button
                                          onClick={() => this.incrementFilter('filterGuests')}
                                          style={{ width: '30px', height: '30px', border: '1px solid #00547e', borderRadius: '6px', background: '#fff', color: '#00547e', fontSize: '18px', cursor: 'pointer' }}
                                        >+</button>
                                      </div>
                                    </div>

                                    {/* Bedrooms */}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 0', borderBottom: '1px solid #eee' }}>
                                      <span style={{ fontSize: '15px', fontWeight: '500', color: '#333' }}>Bedrooms</span>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                        <button
                                          onClick={() => this.decrementFilter('filterBedrooms')}
                                          style={{ width: '30px', height: '30px', border: '1px solid #00547e', borderRadius: '6px', background: '#fff', color: '#00547e', fontSize: '18px', cursor: 'pointer' }}
                                        >−</button>
                                        <span style={{ minWidth: '20px', textAlign: 'center', fontSize: '15px' }}>{this.state.filterBedrooms}</span>
                                        <button
                                          onClick={() => this.incrementFilter('filterBedrooms')}
                                          style={{ width: '30px', height: '30px', border: '1px solid #00547e', borderRadius: '6px', background: '#fff', color: '#00547e', fontSize: '18px', cursor: 'pointer' }}
                                        >+</button>
                                      </div>
                                    </div>

                                    {/* Bathrooms */}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 0', borderBottom: '1px solid #eee' }}>
                                      <span style={{ fontSize: '15px', fontWeight: '500', color: '#333' }}>Bathrooms</span>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                        <button
                                          onClick={() => this.decrementFilter('filterBathrooms')}
                                          style={{ width: '30px', height: '30px', border: '1px solid #00547e', borderRadius: '6px', background: '#fff', color: '#00547e', fontSize: '18px', cursor: 'pointer' }}
                                        >−</button>
                                        <span style={{ minWidth: '20px', textAlign: 'center', fontSize: '15px' }}>{this.state.filterBathrooms}</span>
                                        <button
                                          onClick={() => this.incrementFilter('filterBathrooms')}
                                          style={{ width: '30px', height: '30px', border: '1px solid #00547e', borderRadius: '6px', background: '#fff', color: '#00547e', fontSize: '18px', cursor: 'pointer' }}
                                        >+</button>
                                      </div>
                                    </div>

                                    {/* Lounge */}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 0', borderBottom: '1px solid #eee' }}>
                                      <span style={{ fontSize: '15px', fontWeight: '500', color: '#333' }}>Lounge</span>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                        <button
                                          onClick={() => this.decrementFilter('filterLounge')}
                                          style={{ width: '30px', height: '30px', border: '1px solid #00547e', borderRadius: '6px', background: '#fff', color: '#00547e', fontSize: '18px', cursor: 'pointer' }}
                                        >−</button>
                                        <span style={{ minWidth: '20px', textAlign: 'center', fontSize: '15px' }}>{this.state.filterLounge}</span>
                                        <button
                                          onClick={() => this.incrementFilter('filterLounge')}
                                          style={{ width: '30px', height: '30px', border: '1px solid #00547e', borderRadius: '6px', background: '#fff', color: '#00547e', fontSize: '18px', cursor: 'pointer' }}
                                        >+</button>
                                      </div>
                                    </div>

                                    {/* Comfort Facilities */}
                                    <div style={{ padding: '15px 0' }}>
                                      <div
                                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                                        onClick={() => this.setState({ showFacilitiesDropdown: !this.state.showFacilitiesDropdown })}
                                      >
                                        <span style={{ fontSize: '15px', fontWeight: '500', color: '#333' }}>Comfort Facilities</span>
                                        <span style={{ fontSize: '18px', color: '#00547e' }}>{this.state.showFacilitiesDropdown ? '∧' : '∨'}</span>
                                      </div>
                                      {this.state.showFacilitiesDropdown && this.state.facilityList.length > 0 && (
                                        <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                          {this.state.facilityList.map((facility) => (
                                            <div
                                              key={facility.id}
                                              onClick={() => this.toggleFacility(facility.id)}
                                              style={{
                                                padding: '8px 12px',
                                                borderRadius: '20px',
                                                border: this.state.selectedFacilities.includes(facility.id) ? '2px solid #00547e' : '1px solid #ddd',
                                                backgroundColor: this.state.selectedFacilities.includes(facility.id) ? '#e6f3f8' : '#fff',
                                                cursor: 'pointer',
                                                fontSize: '13px',
                                              }}
                                            >
                                              {facility.name_en || facility.name}
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  {/* Action Buttons */}
                                  <div style={{ display: 'flex', gap: '15px', marginTop: '25px' }}>
                                    <button
                                      type="button"
                                      onClick={this.resetFilters}
                                      disabled={this.state.filterCount === 0}
                                      style={{
                                        flex: 1,
                                        padding: '12px',
                                        border: '1px solid #00547e',
                                        borderRadius: '8px',
                                        background: '#fff',
                                        color: '#00547e',
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        cursor: this.state.filterCount === 0 ? 'not-allowed' : 'pointer',
                                        opacity: this.state.filterCount === 0 ? 0.5 : 1,
                                      }}
                                    >
                                      Reset
                                    </button>
                                    <button
                                      type="button"
                                      onClick={this.applyFilters}
                                      style={{
                                        flex: 1,
                                        padding: '12px',
                                        border: 'none',
                                        borderRadius: '8px',
                                        background: '#00547e',
                                        color: '#fff',
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                      }}
                                    >
                                      Apply
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Chalets Section */}
                          {this.state.categoryList.length > 0 && (
                            <div className="card-padding mb-3">
                              <h2 className="text-heading">Select Chalet</h2>
                              {this.state.isLoadingChalets
                                ? this.renderInlineLoader(120)
                                : this.renderSelectionGrid(
                                  this.state.chaletList,
                                  this.state.chalet_id,
                                  (chalet) => {
                                    this.setState({ chalet_id: chalet.id, maxGuests: chalet.max_guests || 10 }, () =>
                                      this.loadChaletAvailability(chalet.id)
                                    )
                                  },
                                  'Chalets',
                                  'No chalets available',
                                  true
                                )}
                            </div>
                          )}

                          {/* Booking Section - Package & Calendar */}
                          {this.state.categoryList.length > 0 && this.state.chalet_id && (
                            <div className="mt-20">
                              <h2 className="text-heading">Select Package & Dates</h2>
                              {this.state.isLoadingCalendar || this.state.isLoadingChalets
                                ? this.renderInlineLoader(200)
                                : this.renderAvailabilityCalendar()}
                            </div>
                          )}

                          {/* Additional Fields */}
                          <div className="d-flex gap-20 mt-3">
                            <div className="w-100">
                              <div className="additionl-box">
                                <label className="col-form-label colformlabel w-100">Cost Of Service</label>
                                <input
                                  type="number"
                                  min={0}
                                  className="form-control border-radius"
                                  name="cost_of_service"
                                  value={this.state.cost_of_service}
                                  onChange={this.handleChange}
                                  placeholder="Cost Of Service"
                                />
                              </div>
                            </div>
                            <div className="w-100">
                              <div className="additionl-box">
                                <label className="col-form-label colformlabel w-100">Coupon Code</label>
                                <div
                                  className="input-group d-flex"
                                  style={{ marginBottom: '0', overflow: 'hidden' }}
                                >
                                  <input
                                    type="text"
                                    className="form-control border-radius"
                                    name="coupon"
                                    value={this.state.coupon}
                                    onChange={this.handleChange}
                                    placeholder="Coupon Code"
                                    style={{ borderRight: '0' }}
                                    disabled={this.state.isCouponApplied}
                                  />
                                  {this.state.isCouponApplied ? (
                                    <button
                                      className="btn custom-apply-btn"
                                      onClick={this.removeCoupon}
                                      type="button"
                                    >
                                      Remove
                                    </button>
                                  ) : (
                                    <button
                                      className="btn custom-apply-btn"
                                      onClick={this.validateCoupon}
                                      type="button"
                                      disabled={!this.state.coupon.trim()}
                                    >
                                      Apply
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Customer Information */}
                          <div className="d-flex gap-20">
                            <div className="w-100 mt-3">
                              <div className="additionl-box">
                                <label className="col-form-label colformlabel w-100">
                                  Customer Number {this.state.isCustomerOptional ? '(Optional)' : ''}
                                </label>
                                <div className="d-flex form-control contact-filed border-radius">
                                  <input
                                    style={{ width: '30%' }}
                                    type="text"
                                    className="border-none input-border"
                                    name="country_code"
                                    value={this.state.country_code}
                                    onChange={this.handleChange}
                                    placeholder="Country Code"
                                  />
                                  <input
                                    type="text"
                                    className="form-control border-none"
                                    style={{ width: '70%' }}
                                    name="phone"
                                    value={this.state.phone}
                                    onChange={this.handleChange}
                                    placeholder="Contact Number"
                                    maxLength={10}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="w-100 mt-3">
                              <div className="additionl-box">
                                <label className="col-form-label colformlabel w-100">Customer Email (Optional)</label>
                                <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                                  <input
                                    type="email"
                                    className={`form-control border-radius ${this.state.emailError ? 'is-invalid' : ''}`}
                                    name="email"
                                    value={this.state.email}
                                    onChange={this.handleChange}
                                    placeholder="Customer Email"
                                    style={
                                      this.state.emailError
                                        ? { borderColor: '#dc3545', width: '100%' }
                                        : { width: '100%' }
                                    }
                                  />
                                  {this.state.emailError && (
                                    <div
                                      style={{
                                        color: '#dc3545',
                                        fontSize: '12px',
                                        marginTop: '5px',
                                        textAlign: 'left',
                                      }}
                                    >
                                      {this.state.emailError}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Action Buttons */}
                          <div className="d-flex gap-20">
                            <div className="w-100 d-flex mt-3 align-items-end justify-content-end">
                              {this.state.isBooking ? (
                                <button
                                  className="btn btn-grd-disabled mr-2"
                                  disabled
                                >
                                  <i
                                    className="icofont icofont-spinner icofont-spin"
                                    style={{ marginRight: 8 }}
                                  ></i>
                                  Processing Booking...
                                </button>
                              ) : (
                                <>
                                  <button
                                    type="button"
                                    onClick={this.handleBooking}
                                    className="btn book-btn btn-grd-disabled mr-2"
                                  >
                                    <i className="icofont icofont-save"></i> Book
                                  </button>
                                  <button
                                    type="button"
                                    onClick={this.resetForm}
                                    className="btn clear-btn btn-grd-disabled"
                                  >
                                    <i className="icofont icofont-clear"></i> Clear
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.renderChaletDetailsModal()}
        {this.renderPaymentConfirmationModal()}
        {this.renderPackageSelectionModal()}
        {this.renderGlobalPackageModal()}
        {!!this.state.addOnPopUp && !this.state.isCancellingBooking && (
          <div
            className="popup-backdrop"
            onClick={this.cancelChaletBooking}
          >
            <div
              className="popup-content-2 p-0"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="h-100 position-relative">
                <button
                  className="popup-close"
                  onClick={this.cancelChaletBooking}
                >
                  <img
                    src="./assets/icon/concierge/close-black.svg"
                    alt=""
                  />
                </button>
                <ChaletAddOns
                  data={this.state.appOnData}
                  handleDataFromChild={this.handleDataFromChild}
                  clearData={this.resetForm}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default ConciergeChaletAdd